import { createContext, useContext, useState, useEffect, useCallback } from "react";

export const LANGS = ["de", "en", "hr"];

export const translations = {
  de: {
    nav: { references: "Referenzen", services: "Leistungen", industries: "Branchen", process: "Prozess", contact: "Kontakt", startProject: "Projekt starten" },
    hero: {
      kicker: "AI & Business Automation Studio · Wien / Zagreb",
      headline: "AI Solutions. SaaS Platforms. Mobile Apps. Business Automation.",
      subline: "Wir bauen digitale Produkte, die Unternehmen wirklich weiterbringen — AI-gestützte Plattformen, mobile Apps, Automatisierungen und digitale Verkaufsprozesse.",
      ctaPrimary: "Projekt starten",
      ctaSecondary: "Referenzen ansehen",
      proofLabel: "Echte Produkte. Live im Einsatz.",
    },
    intro: {
      s1Kicker: "AI & Business Automation Studio",
      s1Sub: "Wir bauen digitale Produkte, nicht nur Webseiten.",
      s1Scroll: "Scrollen, um zu starten",
      s2Kicker: "Keine normale Webagentur.",
      s2Lines: ["AI Solutions.", "SaaS Platforms.", "Mobile Apps.", "Business Automation."],
      s2Tail: "Vier Disziplinen. Ein Studio.",
      s3Kicker: "Was wir bauen",
      s3Title: "Module echter digitaler Produkte.",
      s4Kicker: "Vom Konzept zum Produkt",
      s4Title: "Von der Idee zum fertigen digitalen Produkt.",
      s4Steps: ["Idee", "MVP", "AI", "App", "Dashboard", "Launch"],
      s5Kicker: "Proof of Work",
      s5Title: "Echte Produkte. Live im Einsatz.",
      s5Sub: "Sechs Plattformen — konzipiert, gebaut und live gebracht.",
      s5Next: "Referenzen",
    },
    hdh: {
      kicker: "Case Study — Digital Transformation",
      headline: "Vom Reparaturshop zum digitalen Premium-Erlebnis.",
      intro: "Digitalisierung eines lokalen Reparaturbetriebs mit Smart Pricing, AI Assistant und Admin-System — aus einem Wiener Reparaturshop wird eine digitale Verkaufs- und Serviceplattform.",
      b1Kicker: "Premium Shop Experience",
      b1Title: "Ein Auftritt wie ein Premium-Tech-Store.",
      b1Text: "Ein lokaler Reparaturshop bekommt einen modernen digitalen Auftritt, der wie ein Premium-Tech-Store wirkt.",
      b1PickupNote: "Abholservice inklusive: Wir holen's ab. Wir bringen's heil.",
      stepKicker: "Repair Configurator",
      stepTitle: "Reparaturpreis in Sekunden.",
      stepText: "Kunden finden in Sekunden den passenden Reparaturpreis — statt anzurufen oder zu warten.",
      smartTitle: "Echte Preise & Smart Pricing.",
      smartText: "Die Plattform arbeitet mit echter Modellstruktur und klaren Reparaturpreisen, damit Kunden sofort verstehen, was ihre Reparatur kostet.",
      steps: [
        { num: "01", label: "Marke wählen" },
        { num: "02", label: "Modell wählen" },
        { num: "03", label: "Reparatur wählen" },
        { num: "04", label: "Preis sofort" },
      ],
      expressTitle: "Express-Slot: Reparatur in 60 Minuten buchbar.",
      expressText: "Klar kommunizierte Express-Reparatur macht aus Dringlichkeit ein Angebot — online buchbar statt Warteschlange.",
      b4Kicker: "AI Shopping Assistant",
      b4Title: "Beratung, die nicht schläft.",
      b4Text: "Ein AI Assistant beantwortet Fragen zu Reparaturen, Modellen, Ablauf und nächsten Schritten — auch außerhalb der Öffnungszeiten.",
      b5Kicker: "Conversion Flow",
      b5Title: "Warenkorb, Anfrage & Checkout.",
      b5Text: "Aus Information wird Aktion: Kunden wählen Reparaturen und Zubehör, legen sie in den Warenkorb und starten den nächsten Schritt.",
      b6Kicker: "Admin & Betrieb",
      b6Title: "Das System hinter dem Store.",
      b6Text: "Der Betreiber pflegt Modelle, Preise und Reparaturangebote selbst — ohne Entwickler.",
      flowKicker: "Live Flow",
      flowTitle: "Der echte Flow — in Bewegung.",
      flowText: "Desktop und Mobile im Originalfluss: vom Einstieg bis zur Anfrage.",
      visit: "hausdeshandys.at ansehen",
    },
    nap: {
      kicker: "Case Study — Automotive AI",
      headline: "AI Performance Advisor für Fahrzeugoptimierung.",
      intro: "Aus einer klassischen Performance-Seite wird ein digitaler AI-Verkaufsprozess: Zulassungsschein hochladen, Fahrzeugdaten automatisch erkennen, Potenzial analysieren und direkt eine Anfrage starten.",
      b1Kicker: "Premium Performance Experience",
      b1Title: "Ein Auftritt wie ein Performance-OS.",
      b1Text: "Premium Dark UI für Automotive Performance — technisch, schnell und seriös. AI-Beratung statt Tuning-Spielerei.",
      ocrKicker: "Kerntechnologie",
      ocrTitle: "OCR Zulassungsschein-Scan.",
      ocrText: "Die KI erkennt Marke, Modell, Motorisierung und Leistung automatisch — direkt aus Foto oder PDF, bequem am Smartphone.",
      stepKicker: "Vom Foto zur Analyse",
      stepTitle: "Ein Upload wird zu Beratung.",
      stepText: "Der gesamte Weg vom Zulassungsschein zur Performance-Einschätzung läuft geführt in wenigen Schritten — ohne Formular-Marathon.",
      steps: [
        { num: "01", label: "Zulassungsschein hochladen", text: "Foto aufnehmen oder Datei wählen — die KI liest die Fahrzeugdaten automatisch aus." },
        { num: "02", label: "Fahrzeugdaten bestätigen", text: "Nur fehlende Angaben wie Kilometerstand, Getriebe und Ziele werden ergänzt." },
        { num: "03", label: "AI Performance Analyse", text: "Der Advisor berechnet realistische Optimierungspotenziale mit Vorher/Nachher-Werten." },
      ],
      b4Kicker: "Leistungsvergleich",
      b4Title: "Das Potenzial — transparent gemacht.",
      b4Text: "Serienleistung im Vergleich zur möglichen Optimierung: PS, Drehmoment, Leistungsgewinn und prozentuale Verbesserung — realistische Werte statt leerer Versprechen.",
      b5Kicker: "Stage-Empfehlungen",
      b5Title: "Empfehlungen, die zum Fahrzeug passen.",
      b5Text: "Der KI Advisor empfiehlt fahrzeugspezifische Stages — inklusive Hinweisen, was ohne Hardware möglich ist und was nicht.",
      b5Note: "Immer als realistische, unverbindliche AI-Einschätzung dargestellt — ohne übertriebene Leistungsversprechen.",
      b6Kicker: "24/7 KI-Chatberater",
      b6Title: "Antworten auch um 23 Uhr.",
      b6Text: "Ein KI-Chatberater beantwortet typische Fragen — etwa zu Garantie und Ablauf — rund um die Uhr und führt zur Anfrage.",
      b7Kicker: "WhatsApp & Lead Flow",
      b7Title: "Aus der Analyse wird eine Anfrage.",
      b7Text: "Angebotsanfrage oder WhatsApp — mit vorausgefüllten Fahrzeug- und Optimierungsdaten. Der komplette Flow, live in Bewegung: vom Upload bis zur Empfehlung.",
      visit: "naperformance.at ansehen",
    },
    naa: {
      kicker: "Case Study — Premium Automotive",
      headline: "Premium Autohaus-Plattform mit AI Photo Studio.",
      intro: "NAAutomobile ist kein Webauftritt, sondern ein digitaler Verkaufs- und Ankaufstrichter: Showroom, Fahrzeugdetail, WhatsApp-Anfrage, Finanzierung, Ankauf, Händler-Dashboard und AI Photo Studio in einer Plattform.",
      b1Kicker: "Premium Digital Showroom",
      b1Title: "Aus einem jungen Autohaus wird ein digitaler Premium-Showroom.",
      b1Text: "Dunkle, ruhige Showroom-UI mit klarer Verkaufsstrecke — Fahrzeugsuche, Fahrzeug anbieten und WhatsApp-Anfrage direkt im Einstieg.",
      b2Kicker: "Fahrzeugbestand & Detailseiten",
      b2Title: "Fahrzeuge, präsentiert wie im Schauraum.",
      b2Text: "Bestand mit Filtern und hochwertige Detailseiten mit Preisbox, Galerie und direkten CTAs: Finanzierung berechnen, Probefahrt, WhatsApp-Anfrage.",
      b3Kicker: "WhatsApp-first Verkauf",
      b3Title: "Keine Formular-Bremse. Direkt ins Gespräch.",
      b3Text: "Interessenten starten mit einem Tap eine vorkonfigurierte WhatsApp-Anfrage zum Fahrzeug — ein echter Conversion-Vorteil für den Händler.",
      b4Kicker: "Finanzierungsrechner",
      b4Title: "Finanzierung greifbar machen.",
      b4Text: "Anzahlung, Laufzeit, Monatsrate und Schlussrate auf einen Blick — Ballonfinanzierung verständlich erklärt.",
      b4Note: "Unverbindliche Beispielrechnung zur Orientierung — keine Kredit- oder Finanzierungszusage.",
      b5Kicker: "Auto verkaufen / KI-Einschätzung",
      b5Title: "Auch der Ankauf wird digital.",
      b5Text: "Kunden bieten ihr Fahrzeug online an — auch beschädigt oder nicht fahrbereit. Die KI liefert in Sekunden eine erste Preisspanne, bevor der Händler übernimmt.",
      b5Note: "Immer als unverbindliche, KI-gestützte Ankaufseinschätzung — die finale Bewertung trifft der Händler.",
      b6Kicker: "Händler-Dashboard",
      b6Title: "Jede Anfrage landet strukturiert im Dashboard.",
      b6Text: "Ankaufanfragen, Reservierungen, Probefahrt- und Finanzierungs-Leads — inklusive Fahrzeugdaten und KI-Voreinschätzung. Statt verlorener Chats: ein geordneter Lead-Eingang.",
      b7Kicker: "AI Photo Studio",
      b7Title: "Fahrzeug bleibt. Showroom entsteht.",
      b7Text: "Das AI Photo Studio macht aus einfachen Fahrzeugfotos hochwertige Showroom-Visuals. View-Lock sorgt dafür, dass Perspektive und Fahrzeugdetails möglichst erhalten bleiben — optimiert werden Hintergrund, Licht und Präsentation.",
      b7SliderHint: "Slider ziehen für den Vergleich",
      baLabelBefore: "Originalfoto",
      baLabelAfter: "AI Showroom Preview",
      viewLockTitle: "View-Lock — kontrollierter AI-Workflow",
      viewLockPoints: [
        "Gleiche Perspektive und Fahrzeugausrichtung",
        "Karosserie, Felgen und Scheinwerfer bleiben erhalten",
        "Keine Drehung, keine Umgestaltung des Fahrzeugs",
        "Nur Hintergrund, Licht, Boden und Showroom-Atmosphäre werden optimiert",
        "Kennzeichen kann neutralisiert werden",
      ],
      b7Note: "AI Showroom Preview — kontrollierter AI-Workflow statt zufälliger Bildgenerierung. Kein Ersatz für finale Verkaufsfotos.",
      b8Kicker: "AI Background Manager",
      b8Title: "Eigene Showroom-Welten für konsistente Präsentation.",
      b8Text: "Nicht nur ein Fotoeffekt: Der Händler wählt und erstellt eigene KI-Hintergründe — Clean Studio, Showroom oder Markenlook — damit der gesamte Bestand einheitlich wirkt.",
      flowKicker: "Live Flow",
      flowTitle: "Der echte Funnel — in Bewegung.",
      flowText: "Desktop und Mobile im Originalfluss: vom Showroom bis zur Anfrage.",
      visit: "naautomobile.at ansehen",
    },
    nova: {
      kicker: "Case Study — Fachlogik als Produkt",
      headline: "Digitaler Autoimport-Assistent mit NoVA-Rule-Engine.",
      intro: "NovaPilot ist kein einfacher Online-Rechner, sondern ein Fachlogik-Produkt: geführter Fall-Assistent, OCR-Dokumente, USt- und Preislogik, Risikoampel und ein nachvollziehbares PDF-Berechnungsprotokoll.",
      b1Kicker: "Das Problem",
      b1Title: "Autoimport ist kompliziert.",
      b1Text: "NoVA, USt, Importart, Fahrzeugdaten, Stichtage und Dokumente machen den Autoimport unübersichtlich. NovaPilot macht daraus einen geführten, dokumentierten Fall.",
      b2Kicker: "Geführter Fall-Assistent",
      b2Title: "Erst der Fall. Dann die Logik.",
      b2Text: "Der Nutzer wählt zuerst den passenden Geschäftsfall — Import aus EU/EWR, Drittstaat-Import, bestehendes AT-Fahrzeug prüfen oder Export mit NoVA-Rückvergütung. Der 6-Step Wizard zerlegt den komplexen Importfall in klare Schritte: Für wen, Fallart, Fahrzeug, USt-Logik, Bewertung, Bestätigung.",
      b3Kicker: "Dokumente & OCR",
      b3Title: "OCR-gestützte Datenerfassung und Dokumentenablage.",
      b3Text: "Zulassungsschein, COC, Rechnungen und weitere Dokumente können fotografiert, hochgeladen, gespeichert und per OCR dem Fall zugeordnet werden.",
      b4Kicker: "Rule Engine & Rechtslagenlogik",
      b4Title: "Keine blinde Formel. Eine Regel-Engine.",
      b4Text: "NoVA ist nicht nur ein Prozentsatz: NovaPilot verbindet Fahrzeugdaten, Preislogik, USt-Kontext und relevante Stichtage zu einem strukturierten Berechnungsfall — inklusive Bemessungsgrundlage, Bewertungswert und Plausibilitätsfragen.",
      ruleTitle: "Rechtslagen, fallbezogen angewendet",
      ruleText: "Die Engine berücksichtigt historische NoVA-Rechtslagen und Regelversionen und wendet sie fallbezogen an: Je nach entscheidendem Datum wird eine passende Regelversion mit Gültigkeitszeitraum, Quelle und Begründung dokumentiert.",
      ruleChips: ["Angewendete Rechtslage", "Regel-ID", "Gültigkeitszeitraum", "Entscheidendes Datum", "Quelle: BMF / RIS NoVAG", "Begründung"],
      b4bKicker: "USt- & Preislogik",
      b4bTitle: "USt-Kontext und Bewertung — Schritt für Schritt.",
      b4bText: "Verkäufer-Typ, USt-Ausweis und Vorsteuerabzug bestimmen den USt-Kontext des Falls. Dazu kommt die Preislogik: Bemessungsgrundlage, Bewertungswert und Quelle werden strukturiert erfasst und später im Protokoll dokumentiert.",
      b5Kicker: "PDF-Berechnungsprotokoll",
      b5Title: "Ergebnisse werden nicht nur angezeigt — sie werden dokumentiert.",
      b5Text: "Jede Berechnung kann als nachvollziehbares Berechnungsprotokoll exportiert werden: Geschäftsfall, Fahrzeugdaten, angewendete Rechtslage, Rechenweg Schritt für Schritt, USt- und Preislogik, Szenarienvergleich, Risikoampel, Dokumenten-Checkliste, Quellen und rechtlicher Disclaimer.",
      b5PdfButton: "Demo-Protokoll ansehen (PDF)",
      b5Chips: ["Angewendete Rechtslage", "Gültigkeitszeitraum", "Regel-ID", "Quelle: BMF / RIS NoVAG", "Begründung", "Rechenweg Schritt für Schritt", "Risikoampel", "Rechtlicher Disclaimer"],
      b5PdfNote: "Demo-Beispiel — eine digitale Vorab-Dokumentation zur Orientierung, keine offizielle Berechnung.",
      wizardSeq: [
        { kicker: "Für wen", title: "Für wen wird gerechnet?", text: "Händler oder Privatperson — der Wizard stellt zuerst die Kontextfrage. Davon hängt ab, welche USt- und Preislogik später greift." },
        { kicker: "Fallart", title: "Welcher Geschäftsfall liegt vor?", text: "Import aus EU/EWR, Drittstaat-Import, bestehendes AT-Fahrzeug prüfen oder Export mit Rückvergütung — die Fallart bestimmt Regelwerk und Stichtage." },
        { kicker: "Fahrzeug", title: "Fahrzeugdaten, strukturiert erfasst.", text: "Erstzulassung, CO2-Wert, Leistung, Kilometerstand: Der Wizard fragt genau die Daten ab, die für die NoVA-Berechnung und die Rechtslagen-Zuordnung entscheidend sind." },
        { kicker: "USt-Logik", title: "Der USt-Kontext des Falls.", text: "Verkäufer-Typ, USt-Ausweis und Vorsteuerabzug werden abgefragt — daraus ergibt sich, wie Kaufpreis und Bemessungsgrundlage zu interpretieren sind." },
        { kicker: "Bewertung", title: "Bewertung, Plausibilität — und dann das Ergebnis.", text: "Bewertungswert und Quelle machen die Bemessungsgrundlage nachvollziehbar. Im letzten Schritt bestätigt der Nutzer die Angaben und erhält die dokumentierte Berechnung." },
      ],
      pdfSeq: [
        { kicker: "Seite 1", title: "Berechnung auf einen Blick.", text: "Geschäftsfall, Fahrzeug, entscheidendes Datum, Bemessungsgrundlage und NoVA-Ergebnis — inklusive Szenarienvergleich und Risikoampel direkt auf der ersten Seite." },
        { kicker: "Seite 2", title: "Rechtsgrundlage & Quelle — dokumentiert.", text: "Angewendete Rechtslage, Gültigkeitszeitraum, Regelversion (Rule-ID), Quelle BMF / RIS NoVAG und die Begründung der Rechtslagen-Zuordnung stehen schwarz auf weiß im Protokoll." },
        { kicker: "Seite 3", title: "Der Rechenweg, Schritt für Schritt.", text: "NoVA-Berechnung im Detail: Grundbetrag, Bonus-Malus, Abzugsposten — plus USt- und Preislogik. Jeder Schritt ist nachvollziehbar aufgeschlüsselt." },
        { kicker: "Seite 4", title: "Bewertung, Risikoampel & Disclaimer.", text: "Abweichungen zwischen Kaufpreis und Bewertung werden geprüft und über die Risikoampel eingestuft. Warnungen, Dokumenten-Checkliste, Quellen und der vollständige rechtliche Hinweis schließen das Protokoll ab." },
      ],
      b6Kicker: "Lead-Funnel & Pro-Modell",
      b6Title: "Aus einer Recherche wird ein Produkt-Funnel.",
      b6Text: "Nutzer können Berechnungen speichern, PDF-Protokolle erzeugen und mit NovaPilot Pro den nächsten Schritt starten — Historie, Dokumentation und PDF-Versand inklusive. Mobile-first, vom Dashboard bis zum Fall.",
      legalNote: "NovaPilot ist eine rechnerische Aufbereitung zur Orientierung — keine Steuerberatung, keine Rechtsberatung und kein offizielles Finanzamt-Tool. Die finale Prüfung erfolgt durch Fachperson oder Behörde.",
      flowKicker: "Live Flow",
      flowTitle: "Der echte Fall-Assistent — in Bewegung.",
      flowText: "Desktop und Mobile im Originalfluss: vom Fall zur dokumentierten Berechnung.",
      visit: "novapilot.at ansehen",
    },
    uh: {
      kicker: "Case Study — Prozess als Produkt",
      headline: "Digitaler Unfallassistent mit KI-Schadenaufnahme.",
      intro: "UnfallHeld verwandelt unstrukturierte Schadenmeldungen in verwertbare digitale Fälle: geführte Unfallmeldung, Foto-Upload, Sprachaufnahme mit KI-Strukturierung, Zulassungsschein-OCR, unverbindliche KI-Ersteinschätzung, PDF-Schadensbericht und Dashboard für den Betrieb.",
      b1Kicker: "Das Problem",
      b1Title: "Schadenmeldungen sind chaotisch.",
      b1Text: "Anrufe, verstreute WhatsApp-Fotos, fehlende Fahrzeugdaten: Für Werkstätten und Lackierereien bedeutet jede Schadenmeldung Rückfragen und Zeitverlust. UnfallHeld macht daraus einen geführten, dokumentierten Fall.",
      b2Kicker: "Geführte Unfallmeldung",
      b2Title: "Sieben klare Schritte statt Formular-Chaos.",
      b2Text: "Der Kunde meldet den Schaden Schritt für Schritt — persönliche Daten, Fahrzeug, Unfall, Fotos, Standort, Unfallgegner, Prüfen & Senden. Mobile-first, direkt im Browser, ohne App-Download.",
      flowSeq: [
        { kicker: "Schritt 1", title: "Persönliche Daten.", text: "Name und Kontakt — mehr braucht der Einstieg nicht. Der Kunde startet die Meldung in Sekunden, ohne Registrierung und ohne App-Download." },
        { kicker: "Schritt 2", title: "Fahrzeug & Zulassungsschein.", text: "Der Zulassungsschein wird fotografiert oder hochgeladen — OCR hilft, Marke, Modell und FIN automatisch in den Fall zu übernehmen." },
        { kicker: "Schritt 3", title: "Unfall einsprechen statt tippen.", text: "Datum, Uhrzeit — und der Unfallhergang als Sprachnachricht. Die KI strukturiert daraus eine editierbare Unfallbeschreibung." },
        { kicker: "Schritt 4", title: "Schadenfotos hochladen.", text: "Geführter Foto-Upload: Übersicht und Details des Schadens werden strukturiert gesammelt — die Grundlage für die spätere KI-Ersteinschätzung." },
        { kicker: "Schritt 5", title: "Unfallort per GPS.", text: "Der Unfallort wird auf der Karte erfasst — ein Tap genügt. So ist der Fall auch örtlich sauber dokumentiert." },
        { kicker: "Schritt 6", title: "Unfallgegner mit KI-Erkennung.", text: "Führerschein- und Zulassungsschein-Foto des Unfallgegners werden KI-gestützt übernommen — inklusive Versicherungsdaten." },
        { kicker: "Schritt 7", title: "Prüfen & senden.", text: "Alle Angaben auf einen Blick, dann absenden: Der Kunde erhält Fallnummer und PIN — der Betrieb einen strukturierten, verwertbaren Fall." },
      ],
      b3Kicker: "Sprechen statt tippen",
      b3Title: "Der Unfallhergang wird einfach eingesprochen.",
      b3Text: "Statt langer Texteingabe nimmt der Kunde den Unfallhergang als Sprachnachricht auf. Daraus entstehen ein Transkript und eine KI-strukturierte, editierbare Unfallbeschreibung.",
      b4Kicker: "Fotos, Standort & Unfallgegner",
      b4Title: "Alle Fakten an einem Ort.",
      b4Text: "Schadenfotos werden strukturiert gesammelt, der Unfallort per GPS erfasst und die Daten des Unfallgegners — inklusive Führerschein- und Zulassungsschein-Foto — KI-gestützt übernommen.",
      b5Kicker: "Zulassungsschein-OCR",
      b5Title: "Fahrzeugdaten ohne Abtippen.",
      b5Text: "Der Zulassungsschein wird fotografiert oder hochgeladen — OCR hilft, Marke, Modell, FIN und Erstzulassung schneller in den Fall zu übernehmen.",
      b6Kicker: "KI-Ersteinschätzung & Status",
      b6Title: "Eine erste Einschätzung — unverbindlich und transparent.",
      b6Text: "Die KI fasst den sichtbaren Schaden strukturiert zusammen: erkannte Bauteile, Schweregrad und Konfidenz. Der Kunde verfolgt den Fall per Fallnummer und PIN über eine Status-Timeline — von der Meldung bis zur Abwicklung.",
      kiTitle: "Vorqualifizierung, kein Gutachten",
      kiText: "Die KI-Ersteinschätzung strukturiert den sichtbaren Schaden als schnellen Startpunkt für die weitere Bearbeitung. Die finale Prüfung erfolgt immer durch Fachbetrieb, Gutachter oder Versicherung.",
      kiChips: ["Erkannte Schäden", "Schweregrad", "Konfidenz", "Unverbindliche Ersteinschätzung", "Dokumenten-Checkliste", "Status-Timeline", "Fallnummer + PIN"],
      b7Kicker: "PDF-Schadensbericht",
      b7Title: "Aus der Meldung wird ein strukturiertes Schaden-Dossier.",
      b7Text: "Jeder Fall kann als PDF-Schadensbericht exportiert werden: Falldaten und Fahrzeug, KI-Ersteinschätzung mit Konfidenz, Original-Sprachtranskript, Unfallfotos, Versicherungszusammenfassung, empfohlene nächste Schritte und ein klarer Hinweis zur Unverbindlichkeit.",
      b7Chips: ["Falldaten & Fahrzeug", "KI-Ersteinschätzung + Konfidenz", "Original-Sprachtranskript", "Unfallfotos", "Versicherungszusammenfassung", "Empfohlene nächste Schritte", "Wichtiger Hinweis (unverbindlich)"],
      b7PdfButton: "Demo-Schadensbericht ansehen (PDF)",
      b7PdfNote: "Demo-Beispiel — eine unverbindliche Ersteinschätzung zur Vorqualifizierung, kein Gutachten.",
      b8Kicker: "Betreiber-Dashboard & Leadflow",
      b8Title: "Jede Meldung wird ein verwertbarer Fall.",
      b8Text: "Im Dashboard sieht der Betrieb alle Schadenfälle mit Status, 10-Sekunden-Briefing, Dokumenten-Checkliste und Schnellkontakt per Anruf oder WhatsApp — vom Eingang bis zum Abschluss.",
      flowKicker: "Live Flow",
      flowTitle: "Der echte Schaden-Assistent — in Bewegung.",
      flowText: "Desktop und Mobile im Originalfluss: von der Meldung zum strukturierten Schadenfall.",
      legalNote: "UnfallHeld liefert eine KI-gestützte, unverbindliche Ersteinschätzung zur Vorqualifizierung — kein Gutachten, keine verbindliche Schadenbewertung oder Kostenangabe, keine Rechtsberatung und keine Deckungszusage. Die finale Prüfung erfolgt durch Fachbetrieb, Gutachter oder Versicherung.",
      visit: "unfallheld.com ansehen",
    },
    wall: {
      kicker: "Referenzen",
      title: "Keine Templates. Echte Produkte.",
      subtitle: "Sechs Plattformen, die wir konzipiert, gebaut und live gebracht haben — von AI-SaaS bis Premium-Commerce.",
      visit: "Live ansehen",
      caseStudy: "Case Study ansehen",
      assetNeeded: "Asset benötigt",
      comingSoon: "Case Study folgt",
    },
    caseNav: {
      back: "Zurück zu den Referenzen",
      viewCase: "Case Study ansehen",
      ctaTitle: "Bereit für dein eigenes Produkt?",
      ctaText: "Lass uns über dein Projekt sprechen — von der Idee bis zum Launch.",
    },
    categories: {
      catAiSaas: "AI SaaS · Asset Intelligence",
      catB2bSaas: "B2B SaaS · TaxTech",
      catInsurtech: "InsurTech · AI Claims",
      catAutomotiveAi: "Automotive AI · Leads",
      catRetail: "Retail · AI Commerce",
      catAutomotive: "Automotive · Plattform",
    },
    projects: {
      dealalert: {
        claim: "AI erkennt Auto- und Immobiliendeals unter Marktpreis — konservativ bewertet.",
        positioning: "AI Asset Intelligence für Auto und Immobilien.",
        description: "DealAlert analysiert Auto- und Immobilienangebote, bewertet Marktpreise konservativ und zeigt echte Unter-Markt-Deals auf Web und iOS.",
      },
      novapilot: {
        claim: "Digitaler Autoimport-Assistent mit NoVA-Rule-Engine.",
        positioning: "Komplexe NoVA-Logik. Einfach geführt.",
        description: "NovaPilot führt durch komplexe NoVA-Fälle für Österreich — mit Rule Engine, geführtem Wizard, OCR-Dokumenten und nachvollziehbarem PDF-Berechnungsprotokoll.",
      },
      unfallheld: {
        claim: "Digitaler Unfallassistent mit KI-Schadenaufnahme.",
        positioning: "Schadenmeldung, OCR und PDF-Dossier in einem mobilen Flow.",
        description: "UnfallHeld digitalisiert die Schadenaufnahme: geführte Unfallmeldung, Foto-Upload, Sprach-Transkript, Zulassungsschein-OCR, unverbindliche KI-Ersteinschätzung, PDF-Schadensbericht und Dashboard für den Betrieb.",
      },
      naperformance: {
        claim: "AI Performance Advisor für Fahrzeugoptimierung.",
        positioning: "AI Performance Advisor für Fahrzeugoptimierung.",
        description: "Zulassungsschein hochladen, KI erkennt das Fahrzeug und erstellt eine realistische Tuning-Analyse mit Vorher/Nachher-Leistungsvergleich und WhatsApp-Lead-Flow.",
      },
      hausdeshandys: {
        claim: "Digitalisierung eines lokalen Reparaturbetriebs mit Smart Pricing, AI Assistant und Admin-System.",
        positioning: "Premium Digitalisierung für Retail & Repair.",
        description: "Repair-Konfigurator mit echten Preisen, AI Shopping Assistant, Partner-Sektionen und Admin Dashboard — eine komplette digitale Shop-Erfahrung.",
      },
      naautomobile: {
        claim: "Premium Autohaus-Plattform mit AI Photo Studio.",
        positioning: "Premium Autohaus-Plattform mit AI Photo Studio.",
        description: "Fahrzeug-Inventory, WhatsApp-first Verkauf, Reservierungsflow, KI-Fahrzeugbewertung, AI Photo Studio und Ballonfinanzierungsrechner.",
      },
    },
    dealalert: {
      kicker: "Flagship Case Study",
      headline: "Von der Idee zur vollständigen AI-Plattform.",
      subline: "DealAlert ist AI-powered Deal Intelligence für Auto- und Immobilienangebote — Marktvergleich statt Versprechen, ein klares Preissignal auf Web und iOS.",
      visit: "dealalert.ai ansehen",
      videoNote: "Screen Recording aus der iOS App",
      problem: {
        kicker: "Das Problem",
        title: "Tausende Inserate. Kaum Vergleichbarkeit.",
        text: "Auto- und Immobilienportale zeigen Inserate — aber nicht, ob ein Angebot wirklich gut ist. Preise sind schwer einzuordnen, Risiken bleiben unsichtbar, und starke Angebote sind oft weg, bevor man sie bewertet hat.",
        points: [
          "Inserate ohne echten Marktkontext",
          "Preisbewertung kostet Stunden Recherche",
          "Gute Angebote verschwinden schnell",
        ],
      },
      solution: {
        kicker: "Die Lösung",
        title: "Eine Plattform, die Inserate versteht.",
        text: "DealAlert aggregiert Angebote, normalisiert Fahrzeug- und Immobiliendaten und vergleicht sie konservativ mit passenden Marktkohorten. Das Ergebnis ist ein nachvollziehbares Preissignal — keine Garantie, sondern eine AI-gestützte Einschätzung.",
        points: [
          "Datenpipeline & Normalisierung",
          "Konservativer Marktvergleich statt Fake-Rabatt",
          "Klares Preissignal direkt am Angebot",
        ],
      },
      flow: {
        kicker: "Product Flow",
        title: "Vom Angebot zur Entscheidung.",
        subtitle: "Vier Schritte: entdecken, bewerten, nachfragen, handeln — auf Web und iOS.",
        steps: [
          { num: "01", label: "Discover", title: "Deals entdecken.", text: "Top Deals und ein swipebarer DealFeed bringen passende Auto- und Immobilienangebote nach vorne — die stärksten Signale zuerst. Entdecken wie in einer modernen Consumer-App." },
          { num: "02", label: "Evaluate", title: "Angebote bewerten.", text: "Die DealCard zeigt Preis, Fahrzeug- bzw. Objektdaten, Bilder und ein konservatives Markt-Signal. Der Vergleich mit ähnlichen Angeboten macht Kontext sichtbar — statt Bauchgefühl." },
          { num: "03", label: "Ask AI", title: "Die KI fragen.", text: "Der AI Deal Advisor erklärt Preis, Risiken, Rendite und Standort — direkt am Angebot. Eine AI-gestützte Einschätzung, die Risiken sichtbarer macht. Keine verbindliche Beratung." },
          { num: "04", label: "Save & Act", title: "Speichern & handeln.", text: "Favoriten sichern, Suchprofile setzen und über Share & Earn weiterempfehlen. Vom Signal zur konkreten nächsten Aktion — schneller eine fundierte Entscheidung treffen." },
        ],
      },
      tech: {
        kicker: "System dahinter",
        title: "Ein echtes SaaS-Produkt — nicht nur eine App.",
        text: "Hinter dem Feed steht eine vollständige Plattform: Datenpipeline, Marktvergleichs-Engine, AI Advisor, Subscription und Admin. Genau das baut CloudService — komplette digitale Produkte statt Webseiten.",
        items: [
          { name: "Data Pipeline", desc: "Apify-gestützter Import & Normalisierung von Auto- und Immobilien-Listings." },
          { name: "Market Engine", desc: "Konservativer Vergleich mit passenden Marktkohorten — schwache Datenbasis, kein Signal." },
          { name: "AI Deal Advisor", desc: "Claude / GPT-gestützte Einschätzung zu Preis, Risiko und Rendite am Angebot." },
          { name: "Image Health Worker", desc: "Prüft und bereinigt Bilddaten, damit der Feed sauber bleibt." },
          { name: "Stripe Subscription", desc: "Abo-Modell mit Referral- und Share-&-Earn-System." },
          { name: "Admin Dashboard", desc: "Pipeline-Monitoring und Listing-Verwaltung an einem Ort." },
        ],
      },
      value: {
        kicker: "Business Value",
        title: "Schneller bessere Entscheidungen.",
        text: "DealAlert macht Risiken sichtbarer und Angebote vergleichbar — damit Nutzer schneller fundiert entscheiden. Bewusst konservativ statt reißerisch: das ist Teil der Produktqualität, keine garantierten Gewinne.",
      },
      stats: [
        { value: 5000, suffix: "+", label: "analysierte Listings" },
        { value: 6, suffix: "", label: "Kernmodule" },
        { value: 2, suffix: "", label: "Plattformen — Web + iOS" },
        { value: 2, suffix: "", label: "Märkte — Auto + Immobilien" },
      ],
      finalCta: {
        kicker: "Das Ergebnis",
        title: "Ein komplettes SaaS-Produkt — live auf dealalert.ai.",
        text: "Web-App, iOS-App, AI Deal Advisor, Datenpipeline, Subscription, Referral und Admin — von CloudService als komplettes Produkt gebaut.",
        primary: "dealalert.ai live ansehen",
      },
    },
    shells: {
      kicker: "Case Study",
      assetNote: "Echte Produkt-Screens folgen — Layout bereit für finale Assets.",
      desktopLabel: "Desktop — Asset benötigt",
      mobileLabel: "Mobile — Asset benötigt",
      visit: "Live ansehen",
    },
    pillars: {
      kicker: "Leistungen",
      title: "Was CloudService baut",
      subtitle: "Vier Kernbereiche — ein Anspruch: echte Produkte statt Baukasten-Webseiten.",
      items: [
        { title: "AI Solutions", text: "KI-Systeme, die echte Prozesse automatisieren.", bullets: ["OCR & Dokumentenerkennung", "AI Advisors & Chatbots", "Bildanalyse & Voice-to-Text"] },
        { title: "SaaS Platforms", text: "Vom Login bis zur Subscription — produktionsreif.", bullets: ["Auth, Stripe & Subscriptions", "User- & Admin-Dashboards", "Skalierbare APIs"] },
        { title: "Mobile Apps", text: "iOS & Android, die sich wie Consumer-Apps anfühlen.", bullets: ["iOS / Android / Expo", "Swipe-Interfaces", "App Store-ready"] },
        { title: "Business Automation", text: "Interne Tools, die Zeit zurückgeben.", bullets: ["CRM & Lead Management", "PDF-Generatoren & Rechnungen", "Dashboards & interne Tools"] },
      ],
    },
    industries: {
      kicker: "Branchen",
      title: "Gebaut für echte Industrien",
      subtitle: "Jede Branche hier ist durch ein echtes, live laufendes Projekt belegt.",
      items: [
        { name: "Automotive", project: "NAAutomobile · NAPerformance" },
        { name: "Real Estate", project: "DealAlert" },
        { name: "Insurance / Claims", project: "UnfallHeld" },
        { name: "Retail / Repair", project: "HausDesHandys" },
        { name: "Tax / Compliance", project: "NovaPilot" },
        { name: "SaaS / Startups", project: "DealAlert · NovaPilot" },
      ],
    },
    process: {
      kicker: "Prozess",
      title: "Von der Idee zum Produkt",
      subtitle: "Klar, schnell, ohne Agentur-Theater.",
      steps: [
        { title: "Idee verstehen", text: "Ziele, Daten, Nutzer und Constraints — wir hören zu, bevor wir bauen." },
        { title: "Produktkonzept definieren", text: "Flows, Architektur und Scope — als klares, gemeinsames Bild." },
        { title: "MVP bauen", text: "Ein funktionierendes Produkt — typischerweise in Wochen, nicht Monaten." },
        { title: "AI & Automation integrieren", text: "OCR, Advisors, Pipelines — dort, wo sie echten Mehrwert bringen." },
        { title: "Live gehen", text: "Deployment, Monitoring, Zahlungsflüsse — produktionsreif." },
        { title: "Weiter verbessern", text: "Iterieren auf Basis echter Nutzung — das Produkt wächst mit." },
      ],
    },
    contact: {
      kicker: "Kontakt",
      title: "Projekt starten",
      subtitle: "Erzähl uns, was du bauen willst. Wir antworten mit konkreten nächsten Schritten — nicht mit einer Standard-Broschüre.",
      name: "Name",
      company: "Firma",
      email: "E-Mail",
      phone: "Telefonnummer",
      projectType: "Projektart",
      projectTypePlaceholder: "Was soll gebaut werden?",
      projectTypes: ["Website", "Web App", "Mobile App", "AI Tool", "Automation", "CRM / Admin Dashboard", "SaaS Plattform", "E-Commerce", "Ich bin mir nicht sicher"],
      industry: "Branche",
      industryPlaceholder: "Branche wählen",
      industryOptions: ["Automotive", "Immobilien", "Versicherung", "Retail / Handel", "Steuern / Compliance", "SaaS / Startup", "Andere"],
      budget: "Budgetrahmen",
      budgetPlaceholder: "Budget wählen",
      budgetOptions: ["< 3.000 €", "3.000 – 10.000 €", "10.000 – 25.000 €", "25.000 € +", "Noch offen"],
      timeline: "Zeitrahmen",
      timelinePlaceholder: "Zeitrahmen wählen",
      timelineOptions: ["So schnell wie möglich / bis 2 Wochen", "Innerhalb von 1 Monat", "1–3 Monate", "3+ Monate", "Noch offen / Beratung gewünscht"],
      description: "Projektbeschreibung",
      descriptionPlaceholder: "Was willst du bauen? Welches Problem soll gelöst werden?",
      file: "Datei anhängen (optional)",
      fileHint: "PDF, Bilder, Docs — max. 10 MB",
      preferredContact: "Bevorzugter Kontakt",
      contactOptions: { email: "E-Mail", phone: "Telefon", whatsapp: "WhatsApp" },
      submit: "Anfrage senden",
      submitting: "Wird gesendet…",
      successTitle: "Anfrage erhalten!",
      successText: "Wir melden uns in der Regel innerhalb von 24 Stunden mit konkreten nächsten Schritten.",
      successWhatsapp: "Direkt per WhatsApp schreiben",
      successEmail: "Oder direkt per E-Mail",
      newRequest: "Neue Anfrage stellen",
      errorRequired: "Bitte fülle alle Pflichtfelder aus.",
      errorSubmit: "Senden fehlgeschlagen. Bitte versuche es erneut.",
      errorFile: "Datei-Upload fehlgeschlagen. Anfrage ohne Datei senden?",
    },
    footer: {
      tagline: "AI Solutions. SaaS Platforms. Mobile Apps. Business Automation.",
      projects: "Projekte",
      legal: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
    },
  },

  en: {
    nav: { references: "Work", services: "Services", industries: "Industries", process: "Process", contact: "Contact", startProject: "Start a project" },
    hero: {
      kicker: "AI & Business Automation Studio · Vienna / Zagreb",
      headline: "AI Solutions. SaaS Platforms. Mobile Apps. Business Automation.",
      subline: "We build digital products that genuinely move companies forward — AI-powered platforms, mobile apps, automation and digital sales processes.",
      ctaPrimary: "Start a project",
      ctaSecondary: "View our work",
      proofLabel: "Real products. Live in production.",
    },
    intro: {
      s1Kicker: "AI & Business Automation Studio",
      s1Sub: "We build digital products, not just websites.",
      s1Scroll: "Scroll to begin",
      s2Kicker: "Not a typical web agency.",
      s2Lines: ["AI Solutions.", "SaaS Platforms.", "Mobile Apps.", "Business Automation."],
      s2Tail: "Four disciplines. One studio.",
      s3Kicker: "What we build",
      s3Title: "Modules of real digital products.",
      s4Kicker: "From concept to product",
      s4Title: "From idea to a finished digital product.",
      s4Steps: ["Idea", "MVP", "AI", "App", "Dashboard", "Launch"],
      s5Kicker: "Proof of work",
      s5Title: "Real products. Live in production.",
      s5Sub: "Six platforms — designed, built and shipped.",
      s5Next: "Work",
    },
    hdh: {
      kicker: "Case Study — Digital Transformation",
      headline: "From repair shop to a digital premium experience.",
      intro: "Digital transformation of a local repair business with smart pricing, an AI assistant and an admin system — turning a Viennese repair shop into a digital sales and service platform.",
      b1Kicker: "Premium Shop Experience",
      b1Title: "A presence like a premium tech store.",
      b1Text: "A local repair shop gets a modern digital presence that feels like a premium tech store.",
      b1PickupNote: "Pickup service included: we collect it, we return it fixed.",
      stepKicker: "Repair Configurator",
      stepTitle: "Repair price in seconds.",
      stepText: "Customers find the right repair price in seconds — instead of calling or waiting.",
      smartTitle: "Real prices & smart pricing.",
      smartText: "The platform works with a real model structure and clear repair prices, so customers instantly understand what their repair costs.",
      steps: [
        { num: "01", label: "Pick a brand" },
        { num: "02", label: "Pick a model" },
        { num: "03", label: "Pick a repair" },
        { num: "04", label: "Instant price" },
      ],
      expressTitle: "Express slot: repaired in 60 minutes.",
      expressText: "Clearly communicated express repair turns urgency into an offer — bookable online instead of queueing.",
      b4Kicker: "AI Shopping Assistant",
      b4Title: "Advice that doesn't sleep.",
      b4Text: "An AI assistant answers questions about repairs, models, process and next steps — even outside opening hours.",
      b5Kicker: "Conversion Flow",
      b5Title: "Cart, request & checkout.",
      b5Text: "Information becomes action: customers pick repairs and accessories, add them to the cart and start the next step.",
      b6Kicker: "Admin & Operations",
      b6Title: "The system behind the store.",
      b6Text: "The owner maintains models, prices and repair offers independently — without a developer.",
      flowKicker: "Live Flow",
      flowTitle: "The real flow — in motion.",
      flowText: "Desktop and mobile in their original flow: from entry to request.",
      visit: "View hausdeshandys.at",
    },
    nap: {
      kicker: "Case Study — Automotive AI",
      headline: "AI performance advisor for vehicle optimisation.",
      intro: "A classic performance site becomes a digital AI sales process: upload the registration document, auto-detect vehicle data, analyse the potential and start a request right away.",
      b1Kicker: "Premium Performance Experience",
      b1Title: "An appearance like a performance OS.",
      b1Text: "Premium dark UI for automotive performance — technical, fast and credible. AI consulting instead of tuning gimmicks.",
      ocrKicker: "Core Technology",
      ocrTitle: "OCR registration document scan.",
      ocrText: "The AI automatically detects make, model, engine and power — straight from a photo or PDF, right on the smartphone.",
      stepKicker: "From photo to analysis",
      stepTitle: "One upload becomes consulting.",
      stepText: "The entire journey from registration document to performance assessment is guided in a few steps — no endless forms.",
      steps: [
        { num: "01", label: "Upload registration document", text: "Take a photo or choose a file — the AI reads the vehicle data automatically." },
        { num: "02", label: "Confirm vehicle data", text: "Only missing details like mileage, transmission and goals are added." },
        { num: "03", label: "AI performance analysis", text: "The advisor calculates realistic optimisation potential with before/after values." },
      ],
      b4Kicker: "Performance Comparison",
      b4Title: "The potential — made transparent.",
      b4Text: "Stock performance versus possible optimisation: HP, torque, performance gain and percentage improvement — realistic values instead of empty promises.",
      b5Kicker: "Stage Recommendations",
      b5Title: "Recommendations that fit the vehicle.",
      b5Text: "The AI advisor recommends vehicle-specific stages — including notes on what is possible without hardware and what is not.",
      b5Note: "Always presented as a realistic, non-binding AI assessment — without exaggerated performance promises.",
      b6Kicker: "24/7 AI Chat Advisor",
      b6Title: "Answers even at 11 pm.",
      b6Text: "An AI chat advisor answers common questions — like warranty and process — around the clock and leads to a request.",
      b7Kicker: "WhatsApp & Lead Flow",
      b7Title: "The analysis becomes a request.",
      b7Text: "Quote request or WhatsApp — with pre-filled vehicle and optimisation data. The complete flow, live in motion: from upload to recommendation.",
      visit: "View naperformance.at",
    },
    naa: {
      kicker: "Case Study — Premium Automotive",
      headline: "Premium dealership platform with AI Photo Studio.",
      intro: "NAAutomobile is not a web presence but a digital sales and purchase funnel: showroom, vehicle detail, WhatsApp inquiry, financing, vehicle purchase, dealer dashboard and AI Photo Studio in one platform.",
      b1Kicker: "Premium Digital Showroom",
      b1Title: "A young dealership becomes a digital premium showroom.",
      b1Text: "Dark, calm showroom UI with a clear sales path — vehicle search, offer-your-car and WhatsApp inquiry right from the start.",
      b2Kicker: "Vehicle Inventory & Detail Pages",
      b2Title: "Vehicles presented like in a showroom.",
      b2Text: "Filterable inventory and high-quality detail pages with price box, gallery and direct CTAs: calculate financing, test drive, WhatsApp inquiry.",
      b3Kicker: "WhatsApp-first Sales",
      b3Title: "No form friction. Straight into the conversation.",
      b3Text: "Prospects start a pre-configured WhatsApp inquiry about the vehicle with one tap — a real conversion advantage for the dealer.",
      b4Kicker: "Financing Calculator",
      b4Title: "Making financing tangible.",
      b4Text: "Down payment, term, monthly rate and final balloon rate at a glance — balloon financing explained clearly.",
      b4Note: "Non-binding example calculation for orientation — no credit or financing commitment.",
      b5Kicker: "Sell Your Car / AI Estimate",
      b5Title: "Vehicle purchase goes digital too.",
      b5Text: "Customers offer their vehicle online — even damaged or not roadworthy. The AI delivers a first price range in seconds before the dealer takes over.",
      b5Note: "Always a non-binding, AI-assisted purchase estimate — the final valuation is made by the dealer.",
      b6Kicker: "Dealer Dashboard",
      b6Title: "Every inquiry lands structured in the dashboard.",
      b6Text: "Purchase inquiries, reservations, test-drive and financing leads — including vehicle data and the AI pre-estimate. Instead of lost chats: an organized lead inbox.",
      b7Kicker: "AI Photo Studio",
      b7Title: "The car stays. The showroom appears.",
      b7Text: "The AI Photo Studio turns simple vehicle photos into high-quality showroom visuals. View-Lock keeps perspective and vehicle details as consistent as possible — only background, light and presentation are optimised.",
      b7SliderHint: "Drag the slider to compare",
      baLabelBefore: "Original photo",
      baLabelAfter: "AI Showroom Preview",
      viewLockTitle: "View-Lock — a controlled AI workflow",
      viewLockPoints: [
        "Same perspective and vehicle orientation",
        "Body, wheels and headlights are preserved",
        "No rotation, no redesign of the car",
        "Only background, light, floor and showroom atmosphere are optimised",
        "License plate can be neutralised",
      ],
      b7Note: "AI Showroom Preview — a controlled AI workflow instead of random image generation. Not a replacement for final sales photos.",
      b8Kicker: "AI Background Manager",
      b8Title: "Own showroom worlds for consistent presentation.",
      b8Text: "Not just a photo effect: the dealer selects and creates own AI backgrounds — clean studio, showroom or brand look — so the whole inventory looks consistent.",
      flowKicker: "Live Flow",
      flowTitle: "The real funnel — in motion.",
      flowText: "Desktop and mobile in their original flow: from showroom to inquiry.",
      visit: "View naautomobile.at",
    },
    nova: {
      kicker: "Case Study — Domain Logic as a Product",
      headline: "Digital car-import assistant with a NoVA rule engine.",
      intro: "NovaPilot is not a simple online calculator but a domain-logic product: guided case assistant, OCR documents, VAT and price logic, risk indicator and a traceable PDF calculation protocol.",
      b1Kicker: "The Problem",
      b1Title: "Importing a car is complicated.",
      b1Text: "NoVA, VAT, import type, vehicle data, key dates and documents make car imports confusing. NovaPilot turns this into a guided, documented case.",
      b2Kicker: "Guided Case Assistant",
      b2Title: "The case first. Then the logic.",
      b2Text: "Users first pick the matching business case — import from EU/EEA, third-country import, checking an existing AT vehicle or export with NoVA refund. The 6-step wizard breaks the complex import case into clear steps: who it's for, case type, vehicle, VAT logic, valuation, confirmation.",
      b3Kicker: "Documents & OCR",
      b3Title: "OCR-assisted data capture and document storage.",
      b3Text: "Registration document, COC, invoices and other documents can be photographed, uploaded, stored and assigned to the case via OCR.",
      b4Kicker: "Rule Engine & Legal-Version Logic",
      b4Title: "No blind formula. A rule engine.",
      b4Text: "NoVA is not just a percentage: NovaPilot combines vehicle data, price logic, VAT context and relevant key dates into a structured calculation case — including assessment base, valuation value and plausibility questions.",
      ruleTitle: "Legal versions, applied per case",
      ruleText: "The engine takes historical NoVA legal versions and rule versions into account and applies them per case: depending on the decisive date, a matching rule version is documented with validity period, source and reasoning.",
      ruleChips: ["Applied legal version", "Rule ID", "Validity period", "Decisive date", "Source: BMF / RIS NoVAG", "Reasoning"],
      b4bKicker: "VAT & Price Logic",
      b4bTitle: "VAT context and valuation — step by step.",
      b4bText: "Seller type, VAT disclosure and input tax deduction define the VAT context of the case. On top of that comes the price logic: assessment base, valuation value and source are captured in a structured way and later documented in the protocol.",
      b5Kicker: "PDF Calculation Protocol",
      b5Title: "Results are not just displayed — they are documented.",
      b5Text: "Every calculation can be exported as a traceable protocol: business case, vehicle data, applied legal version, step-by-step calculation path, VAT and price logic, scenario comparison, risk indicator, document checklist, sources and legal disclaimer.",
      b5PdfButton: "View demo protocol (PDF)",
      b5Chips: ["Applied legal version", "Validity period", "Rule ID", "Source: BMF / RIS NoVAG", "Reasoning", "Step-by-step calculation path", "Risk indicator", "Legal disclaimer"],
      b5PdfNote: "Demo example — a digital preliminary documentation for orientation, not an official calculation.",
      wizardSeq: [
        { kicker: "Who", title: "Who is the calculation for?", text: "Dealer or private person — the wizard asks the context question first. This determines which VAT and price logic applies later." },
        { kicker: "Case Type", title: "Which business case applies?", text: "Import from EU/EEA, third-country import, checking an existing AT vehicle or export with refund — the case type defines the rule set and decisive dates." },
        { kicker: "Vehicle", title: "Vehicle data, captured in a structured way.", text: "First registration, CO2 value, power, mileage: the wizard asks exactly for the data that matters for the NoVA calculation and the legal-version mapping." },
        { kicker: "VAT Logic", title: "The VAT context of the case.", text: "Seller type, VAT disclosure and input tax deduction are captured — this defines how purchase price and assessment base are to be interpreted." },
        { kicker: "Valuation", title: "Valuation, plausibility — then the result.", text: "Valuation value and source make the assessment base traceable. In the final step the user confirms the inputs and receives the documented calculation." },
      ],
      pdfSeq: [
        { kicker: "Page 1", title: "The calculation at a glance.", text: "Business case, vehicle, decisive date, assessment base and NoVA result — including scenario comparison and risk indicator right on the first page." },
        { kicker: "Page 2", title: "Legal basis & source — documented.", text: "Applied legal version, validity period, rule version (Rule-ID), source BMF / RIS NoVAG and the reasoning for the legal mapping are documented in black and white." },
        { kicker: "Page 3", title: "The calculation path, step by step.", text: "NoVA calculation in detail: base amount, bonus-malus, deduction items — plus VAT and price logic. Every step is broken down transparently." },
        { kicker: "Page 4", title: "Valuation, risk indicator & disclaimer.", text: "Deviations between purchase price and valuation are checked and rated via the risk indicator. Warnings, document checklist, sources and the full legal notice complete the protocol." },
      ],
      b6Kicker: "Lead Funnel & Pro Model",
      b6Title: "A research task becomes a product funnel.",
      b6Text: "Users can save calculations, generate PDF protocols and take the next step with NovaPilot Pro — history, documentation and PDF delivery included. Mobile-first, from dashboard to case.",
      legalNote: "NovaPilot is a computational preparation for orientation — no tax advice, no legal advice and no official tax-office tool. Final review is done by a professional or the authority.",
      flowKicker: "Live Flow",
      flowTitle: "The real case assistant — in motion.",
      flowText: "Desktop and mobile in their original flow: from case to documented calculation.",
      visit: "View novapilot.at",
    },
    uh: {
      kicker: "Case Study — Process as a Product",
      headline: "Digital accident assistant with AI-supported damage intake.",
      intro: "UnfallHeld turns unstructured damage reports into usable digital cases: guided accident reporting, photo upload, voice recording with AI structuring, registration-document OCR, a non-binding AI initial assessment, a PDF damage report and a dashboard for the workshop.",
      b1Kicker: "The Problem",
      b1Title: "Damage reports are chaotic.",
      b1Text: "Phone calls, scattered WhatsApp photos, missing vehicle data: for workshops and paint shops, every damage report means follow-up questions and lost time. UnfallHeld turns it into a guided, documented case.",
      b2Kicker: "Guided Accident Report",
      b2Title: "Seven clear steps instead of form chaos.",
      b2Text: "The customer reports the damage step by step — personal data, vehicle, accident, photos, location, other party, review & send. Mobile-first, directly in the browser, no app download.",
      flowSeq: [
        { kicker: "Step 1", title: "Personal data.", text: "Name and contact — that's all it takes to start. The customer begins the report in seconds, without registration and without an app download." },
        { kicker: "Step 2", title: "Vehicle & registration document.", text: "The registration document is photographed or uploaded — OCR helps transfer make, model and VIN into the case automatically." },
        { kicker: "Step 3", title: "Speak the accident instead of typing.", text: "Date, time — and the course of the accident as a voice message. The AI structures it into an editable accident description." },
        { kicker: "Step 4", title: "Upload damage photos.", text: "Guided photo upload: overview and detail shots of the damage are collected in a structured way — the basis for the later AI initial assessment." },
        { kicker: "Step 5", title: "Accident location via GPS.", text: "The accident location is captured on the map — one tap is enough. The case is cleanly documented, including the location." },
        { kicker: "Step 6", title: "Other party with AI recognition.", text: "Photos of the other party's driving licence and registration document are taken over with AI support — including insurance details." },
        { kicker: "Step 7", title: "Review & send.", text: "All details at a glance, then submit: the customer receives a case number and PIN — the workshop gets a structured, usable case." },
      ],
      b3Kicker: "Speak Instead of Type",
      b3Title: "The accident is simply spoken.",
      b3Text: "Instead of long text input, the customer records the course of the accident as a voice note. This produces a transcript and an AI-structured, editable accident description.",
      b4Kicker: "Photos, Location & Other Party",
      b4Title: "All facts in one place.",
      b4Text: "Damage photos are collected in a structured way, the accident location is captured via GPS and the other party's data — including driving licence and registration photos — is taken over with AI support.",
      b5Kicker: "Registration OCR",
      b5Title: "Vehicle data without retyping.",
      b5Text: "The registration document is photographed or uploaded — OCR helps transfer make, model, VIN and first registration into the case faster.",
      b6Kicker: "AI Initial Assessment & Status",
      b6Title: "A first assessment — non-binding and transparent.",
      b6Text: "The AI summarises the visible damage in a structured way: detected components, severity and confidence. The customer tracks the case via case number and PIN on a status timeline — from report to settlement.",
      kiTitle: "Pre-qualification, not an expert opinion",
      kiText: "The AI initial assessment structures the visible damage as a fast starting point for further processing. The final assessment is always done by the workshop, an expert or the insurer.",
      kiChips: ["Detected damages", "Severity", "Confidence", "Non-binding initial assessment", "Document checklist", "Status timeline", "Case number + PIN"],
      b7Kicker: "PDF Damage Report",
      b7Title: "The report becomes a structured damage dossier.",
      b7Text: "Every case can be exported as a PDF damage report: case and vehicle data, AI initial assessment with confidence, original voice transcript, accident photos, insurance summary, recommended next steps and a clear non-binding notice.",
      b7Chips: ["Case & vehicle data", "AI assessment + confidence", "Original voice transcript", "Accident photos", "Insurance summary", "Recommended next steps", "Important notice (non-binding)"],
      b7PdfButton: "View demo damage report (PDF)",
      b7PdfNote: "Demo example — a non-binding initial assessment for pre-qualification, not an expert opinion.",
      b8Kicker: "Operator Dashboard & Lead Flow",
      b8Title: "Every report becomes a usable case.",
      b8Text: "In the dashboard, the workshop sees all damage cases with status, a 10-second briefing, document checklist and quick contact via call or WhatsApp — from intake to completion.",
      flowKicker: "Live Flow",
      flowTitle: "The real claims assistant — in motion.",
      flowText: "Desktop and mobile in the original flow: from report to structured damage case.",
      legalNote: "UnfallHeld provides an AI-supported, non-binding initial assessment for pre-qualification — not an expert opinion, no binding damage valuation or cost figure, no legal advice and no coverage commitment. The final assessment is done by the workshop, an expert or the insurer.",
      visit: "View unfallheld.com",
    },
    wall: {
      kicker: "Work",
      title: "No templates. Real products.",
      subtitle: "Six platforms we designed, built and shipped — from AI SaaS to premium commerce.",
      visit: "View live",
      caseStudy: "View case study",
      assetNeeded: "Asset needed",
      comingSoon: "Case study coming",
    },
    caseNav: {
      back: "Back to references",
      viewCase: "View case study",
      ctaTitle: "Ready to build your own product?",
      ctaText: "Let's talk about your project — from idea to launch.",
    },
    categories: {
      catAiSaas: "AI SaaS · Asset Intelligence",
      catB2bSaas: "B2B SaaS · TaxTech",
      catInsurtech: "InsurTech · AI Claims",
      catAutomotiveAi: "Automotive AI · Leads",
      catRetail: "Retail · AI Commerce",
      catAutomotive: "Automotive · Platform",
    },
    projects: {
      dealalert: {
        claim: "AI surfaces car and real estate deals below market price — conservatively evaluated.",
        positioning: "AI asset intelligence for cars and real estate.",
        description: "DealAlert analyses car and property listings, evaluates market prices conservatively and surfaces genuine below-market deals — on web and iOS.",
      },
      novapilot: {
        claim: "Digital car-import assistant with a NoVA rule engine.",
        positioning: "Complex NoVA logic. Simply guided.",
        description: "NovaPilot guides users through complex Austrian NoVA cases — rule engine, guided wizard, OCR documents and a traceable PDF calculation protocol.",
      },
      unfallheld: {
        claim: "Digital accident assistant with AI-supported damage intake.",
        positioning: "Damage report, OCR and PDF dossier in one mobile flow.",
        description: "UnfallHeld digitises damage intake: guided accident report, photo upload, voice transcript, registration-document OCR, non-binding AI initial assessment, PDF damage report and an operator dashboard.",
      },
      naperformance: {
        claim: "AI performance advisor for vehicle optimisation.",
        positioning: "AI performance advisor for vehicle optimisation.",
        description: "Upload your registration document — AI recognises the vehicle and creates a realistic tuning analysis with before/after comparison and WhatsApp lead flow.",
      },
      hausdeshandys: {
        claim: "Premium digitalisation for a smartphone repair shop.",
        positioning: "Premium digitalisation for retail & repair.",
        description: "Repair configurator with real prices, AI shopping assistant, partner sections and admin dashboard — a complete digital shop experience.",
      },
      naautomobile: {
        claim: "Premium dealership platform with AI Photo Studio.",
        positioning: "Premium dealership platform with AI Photo Studio.",
        description: "Vehicle inventory, WhatsApp-first sales, reservation flow, AI vehicle valuation, AI Photo Studio and balloon financing calculator.",
      },
    },
    dealalert: {
      kicker: "Flagship case study",
      headline: "From idea to a complete AI platform.",
      subline: "DealAlert is AI-powered deal intelligence for car and real estate listings — market comparison instead of promises, a clear price signal on web and iOS.",
      visit: "Visit dealalert.ai",
      videoNote: "Screen recording from the iOS app",
      problem: {
        kicker: "The problem",
        title: "Thousands of listings. Barely comparable.",
        text: "Car and property portals show listings — but not whether an offer is actually good. Prices are hard to judge, risks stay invisible, and strong deals are often gone before you've evaluated them.",
        points: [
          "Listings without real market context",
          "Price evaluation takes hours of research",
          "Good offers disappear fast",
        ],
      },
      solution: {
        kicker: "The solution",
        title: "A platform that understands listings.",
        text: "DealAlert aggregates listings, normalises vehicle and property data and compares them conservatively against matching market cohorts. The result is a traceable price signal — not a guarantee, but an AI-supported assessment.",
        points: [
          "Data pipeline & normalisation",
          "Conservative market comparison, no fake discounts",
          "A clear price signal right on the listing",
        ],
      },
      flow: {
        kicker: "Product flow",
        title: "From a listing to a decision.",
        subtitle: "Four steps: discover, evaluate, ask AI, act — on web and iOS.",
        steps: [
          { num: "01", label: "Discover", title: "Discover deals.", text: "Top Deals and a swipeable DealFeed surface matching car and property listings — the strongest signals first. Discovery like in a modern consumer app." },
          { num: "02", label: "Evaluate", title: "Evaluate offers.", text: "The DealCard shows price, vehicle or property data, images and a conservative market signal. Comparing with similar offers makes context visible — instead of gut feeling." },
          { num: "03", label: "Ask AI", title: "Ask the AI.", text: "The AI Deal Advisor explains price, risks, yield and location — right on the listing. An AI-supported assessment that makes risks more visible. Not binding advice." },
          { num: "04", label: "Save & Act", title: "Save & act.", text: "Save favourites, set search profiles and refer others via Share & Earn. From signal to the concrete next action — making a well-founded decision faster." },
        ],
      },
      tech: {
        kicker: "The system behind it",
        title: "A real SaaS product — not just an app.",
        text: "Behind the feed sits a complete platform: data pipeline, market comparison engine, AI advisor, subscription and admin. That's exactly what CloudService builds — complete digital products instead of websites.",
        items: [
          { name: "Data pipeline", desc: "Apify-driven import & normalisation of car and real estate listings." },
          { name: "Market engine", desc: "Conservative comparison with matching market cohorts — weak data, no signal." },
          { name: "AI Deal Advisor", desc: "Claude / GPT-supported assessment of price, risk and yield on the listing." },
          { name: "Image health worker", desc: "Checks and cleans image data to keep the feed clean." },
          { name: "Stripe subscription", desc: "Subscription model with referral and Share & Earn system." },
          { name: "Admin dashboard", desc: "Pipeline monitoring and listing management in one place." },
        ],
      },
      value: {
        kicker: "Business value",
        title: "Better decisions, faster.",
        text: "DealAlert makes risks more visible and offers comparable — so users decide faster and better-informed. Deliberately conservative rather than flashy: that's part of the product quality, no guaranteed gains.",
      },
      stats: [
        { value: 5000, suffix: "+", label: "listings analysed" },
        { value: 6, suffix: "", label: "core modules" },
        { value: 2, suffix: "", label: "platforms — web + iOS" },
        { value: 2, suffix: "", label: "markets — cars + real estate" },
      ],
      finalCta: {
        kicker: "The result",
        title: "A complete SaaS product — live on dealalert.ai.",
        text: "Web app, iOS app, AI Deal Advisor, data pipeline, subscription, referral and admin — built by CloudService as a complete product.",
        primary: "View dealalert.ai live",
      },
    },
    shells: {
      kicker: "Case study",
      assetNote: "Real product screens coming — layout ready for final assets.",
      desktopLabel: "Desktop — asset needed",
      mobileLabel: "Mobile — asset needed",
      visit: "View live",
    },
    pillars: {
      kicker: "Services",
      title: "What CloudService builds",
      subtitle: "Four core areas — one standard: real products instead of website builders.",
      items: [
        { title: "AI Solutions", text: "AI systems that automate real processes.", bullets: ["OCR & document recognition", "AI advisors & chatbots", "Image analysis & voice-to-text"] },
        { title: "SaaS Platforms", text: "From login to subscription — production-ready.", bullets: ["Auth, Stripe & subscriptions", "User & admin dashboards", "Scalable APIs"] },
        { title: "Mobile Apps", text: "iOS & Android that feel like consumer apps.", bullets: ["iOS / Android / Expo", "Swipe interfaces", "App Store-ready"] },
        { title: "Business Automation", text: "Internal tools that give time back.", bullets: ["CRM & lead management", "PDF generators & invoicing", "Dashboards & internal tools"] },
      ],
    },
    industries: {
      kicker: "Industries",
      title: "Built for real industries",
      subtitle: "Every industry here is backed by a real project running live.",
      items: [
        { name: "Automotive", project: "NAAutomobile · NAPerformance" },
        { name: "Real Estate", project: "DealAlert" },
        { name: "Insurance / Claims", project: "UnfallHeld" },
        { name: "Retail / Repair", project: "HausDesHandys" },
        { name: "Tax / Compliance", project: "NovaPilot" },
        { name: "SaaS / Startups", project: "DealAlert · NovaPilot" },
      ],
    },
    process: {
      kicker: "Process",
      title: "From idea to product",
      subtitle: "Clear, fast, without agency theatre.",
      steps: [
        { title: "Understand the idea", text: "Goals, data, users and constraints — we listen before we build." },
        { title: "Define the product concept", text: "Flows, architecture and scope — as one clear shared picture." },
        { title: "Build the MVP", text: "A working product — typically in weeks, not months." },
        { title: "Integrate AI & automation", text: "OCR, advisors, pipelines — where they create real value." },
        { title: "Go live", text: "Deployment, monitoring, payment flows — production-ready." },
        { title: "Keep improving", text: "Iterate based on real usage — the product grows with you." },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Start a project",
      subtitle: "Tell us what you want to build. We reply with concrete next steps — not a standard brochure.",
      name: "Name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      projectType: "Project type",
      projectTypePlaceholder: "What should be built?",
      projectTypes: ["Website", "Web App", "Mobile App", "AI Tool", "Automation", "CRM / Admin Dashboard", "SaaS Platform", "E-Commerce", "Not sure yet"],
      industry: "Industry",
      industryPlaceholder: "Select industry",
      industryOptions: ["Automotive", "Real Estate", "Insurance", "Retail", "Tax / Compliance", "SaaS / Startup", "Other"],
      budget: "Budget range",
      budgetPlaceholder: "Select budget",
      budgetOptions: ["< €3,000", "€3,000 – €10,000", "€10,000 – €25,000", "€25,000 +", "Open"],
      timeline: "Timeline",
      timelinePlaceholder: "Select timeline",
      timelineOptions: ["As soon as possible / within 2 weeks", "Within 1 month", "1–3 months", "3+ months", "Still open / consultation wanted"],
      description: "Project description",
      descriptionPlaceholder: "What do you want to build? What problem should it solve?",
      file: "Attach file (optional)",
      fileHint: "PDF, images, docs — max. 10 MB",
      preferredContact: "Preferred contact",
      contactOptions: { email: "Email", phone: "Phone", whatsapp: "WhatsApp" },
      submit: "Send request",
      submitting: "Sending…",
      successTitle: "Request received!",
      successText: "We usually get back to you within 24 hours with concrete next steps.",
      successWhatsapp: "Message us on WhatsApp",
      successEmail: "Or email us directly",
      newRequest: "Send another request",
      errorRequired: "Please fill in all required fields.",
      errorSubmit: "Sending failed. Please try again.",
      errorFile: "File upload failed. Send request without file?",
    },
    footer: {
      tagline: "AI Solutions. SaaS Platforms. Mobile Apps. Business Automation.",
      projects: "Projects",
      legal: "Legal",
      imprint: "Imprint",
      privacy: "Privacy",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },

  hr: {
    nav: { references: "Reference", services: "Usluge", industries: "Industrije", process: "Proces", contact: "Kontakt", startProject: "Pokreni projekt" },
    hero: {
      kicker: "AI & Business Automation Studio · Beč / Zagreb",
      headline: "AI Solutions. SaaS Platforms. Mobile Apps. Business Automation.",
      subline: "Gradimo digitalne proizvode koji tvrtke stvarno pokreću naprijed — AI platforme, mobilne aplikacije, automatizacije i digitalne prodajne procese.",
      ctaPrimary: "Pokreni projekt",
      ctaSecondary: "Pogledaj reference",
      proofLabel: "Stvarni proizvodi. Uživo u produkciji.",
    },
    intro: {
      s1Kicker: "AI & Business Automation Studio",
      s1Sub: "Gradimo digitalne proizvode, ne samo web stranice.",
      s1Scroll: "Scrollaj za početak",
      s2Kicker: "Nismo tipična web agencija.",
      s2Lines: ["AI Solutions.", "SaaS Platforms.", "Mobile Apps.", "Business Automation."],
      s2Tail: "Četiri discipline. Jedan studio.",
      s3Kicker: "Što gradimo",
      s3Title: "Moduli stvarnih digitalnih proizvoda.",
      s4Kicker: "Od koncepta do proizvoda",
      s4Title: "Od ideje do gotovog digitalnog proizvoda.",
      s4Steps: ["Ideja", "MVP", "AI", "App", "Dashboard", "Launch"],
      s5Kicker: "Proof of work",
      s5Title: "Stvarni proizvodi. Uživo u produkciji.",
      s5Sub: "Šest platformi — osmišljeno, izgrađeno i lansirano.",
      s5Next: "Reference",
    },
    hdh: {
      kicker: "Case Study — Digitalna transformacija",
      headline: "Od servisa do digitalnog premium iskustva.",
      intro: "Digitalizacija lokalnog servisa s pametnim cijenama, AI asistentom i admin sustavom — bečki servis mobitela postaje digitalna prodajna i servisna platforma.",
      b1Kicker: "Premium Shop Experience",
      b1Title: "Nastup poput premium tech trgovine.",
      b1Text: "Lokalni servis dobiva moderan digitalni nastup koji djeluje poput premium tech trgovine.",
      b1PickupNote: "Uključena dostava: preuzimamo uređaj i vraćamo ga popravljenog.",
      stepKicker: "Repair Configurator",
      stepTitle: "Cijena popravka u sekundama.",
      stepText: "Kupci u sekundama pronalaze točnu cijenu popravka — umjesto poziva ili čekanja.",
      smartTitle: "Stvarne cijene i smart pricing.",
      smartText: "Platforma radi sa stvarnom strukturom modela i jasnim cijenama popravaka, pa kupci odmah razumiju koliko popravak košta.",
      steps: [
        { num: "01", label: "Odaberi marku" },
        { num: "02", label: "Odaberi model" },
        { num: "03", label: "Odaberi popravak" },
        { num: "04", label: "Odmah cijena" },
      ],
      expressTitle: "Express termin: popravak u 60 minuta uz online rezervaciju.",
      expressText: "Jasno komunicirani express popravak pretvara hitnost u ponudu — rezervacija online umjesto čekanja u redu.",
      b4Kicker: "AI Shopping Assistant",
      b4Title: "Savjetovanje koje ne spava.",
      b4Text: "AI asistent odgovara na pitanja o popravcima, modelima, procesu i sljedećim koracima — i izvan radnog vremena.",
      b5Kicker: "Conversion Flow",
      b5Title: "Košarica, upit i checkout.",
      b5Text: "Informacija postaje akcija: kupci biraju popravke i dodatke, stavljaju ih u košaricu i pokreću sljedeći korak.",
      b6Kicker: "Admin i poslovanje",
      b6Title: "Sustav iza trgovine.",
      b6Text: "Vlasnik sam održava modele, cijene i ponude popravaka — bez developera.",
      flowKicker: "Live Flow",
      flowTitle: "Stvarni flow — u pokretu.",
      flowText: "Desktop i mobile u izvornom tijeku: od ulaska do upita.",
      visit: "Pogledaj hausdeshandys.at",
    },
    nap: {
      kicker: "Case Study — Automotive AI",
      headline: "AI performance advisor za optimizaciju vozila.",
      intro: "Klasična performance stranica postaje digitalni AI prodajni proces: učitaj prometnu dozvolu, automatski prepoznaj podatke o vozilu, analiziraj potencijal i odmah pokreni upit.",
      b1Kicker: "Premium Performance Experience",
      b1Title: "Nastup poput performance OS-a.",
      b1Text: "Premium tamni UI za automotive performance — tehnički, brz i ozbiljan. AI savjetovanje umjesto tuning trikova.",
      ocrKicker: "Ključna tehnologija",
      ocrTitle: "OCR sken prometne dozvole.",
      ocrText: "AI automatski prepoznaje marku, model, motorizaciju i snagu — izravno iz fotografije ili PDF-a, izravno na smartphoneu.",
      stepKicker: "Od fotografije do analize",
      stepTitle: "Jedan upload postaje savjetovanje.",
      stepText: "Cijeli put od prometne dozvole do procjene performansi vođen je u nekoliko koraka — bez beskonačnih formulara.",
      steps: [
        { num: "01", label: "Učitaj prometnu dozvolu", text: "Snimi fotografiju ili odaberi datoteku — AI automatski čita podatke o vozilu." },
        { num: "02", label: "Potvrdi podatke o vozilu", text: "Dodaju se samo podaci koji nedostaju, poput kilometraže, mjenjača i ciljeva." },
        { num: "03", label: "AI analiza performansi", text: "Advisor izračunava realističan potencijal optimizacije s vrijednostima prije/poslije." },
      ],
      b4Kicker: "Usporedba performansi",
      b4Title: "Potencijal — transparentno prikazan.",
      b4Text: "Serijska snaga u usporedbi s mogućom optimizacijom: KS, okretni moment, dobitak snage i postotno poboljšanje — realistične vrijednosti umjesto praznih obećanja.",
      b5Kicker: "Stage preporuke",
      b5Title: "Preporuke koje odgovaraju vozilu.",
      b5Text: "AI advisor preporučuje stageove specifične za vozilo — uključujući napomene što je moguće bez hardvera, a što nije.",
      b5Note: "Uvijek prikazano kao realistična, neobvezujuća AI procjena — bez pretjeranih obećanja o snazi.",
      b6Kicker: "24/7 AI chat savjetnik",
      b6Title: "Odgovori i u 23 sata.",
      b6Text: "AI chat savjetnik odgovara na tipična pitanja — npr. o jamstvu i procesu — 0-24 i vodi do upita.",
      b7Kicker: "WhatsApp & Lead Flow",
      b7Title: "Analiza postaje upit.",
      b7Text: "Upit za ponudu ili WhatsApp — s unaprijed ispunjenim podacima o vozilu i optimizaciji. Cijeli flow, uživo u pokretu: od uploada do preporuke.",
      visit: "Pogledaj naperformance.at",
    },
    naa: {
      kicker: "Case Study — Premium Automotive",
      headline: "Premium platforma za autokuću s AI Photo Studiom.",
      intro: "NAAutomobile nije web stranica, već digitalni prodajni i otkupni lijevak: showroom, detalji vozila, WhatsApp upit, financiranje, otkup, dashboard za trgovca i AI Photo Studio u jednoj platformi.",
      b1Kicker: "Premium Digital Showroom",
      b1Title: "Mlada autokuća postaje digitalni premium showroom.",
      b1Text: "Tamni, smireni showroom UI s jasnim prodajnim putem — pretraga vozila, ponuda vozila i WhatsApp upit odmah na ulazu.",
      b2Kicker: "Inventar vozila i detaljne stranice",
      b2Title: "Vozila prezentirana kao u salonu.",
      b2Text: "Inventar s filterima i kvalitetne detaljne stranice s cijenom, galerijom i izravnim CTA-ovima: izračun financiranja, probna vožnja, WhatsApp upit.",
      b3Kicker: "WhatsApp-first prodaja",
      b3Title: "Bez kočenja formularima. Izravno u razgovor.",
      b3Text: "Zainteresirani jednim dodirom pokreću unaprijed pripremljeni WhatsApp upit o vozilu — stvarna prednost konverzije za trgovca.",
      b4Kicker: "Kalkulator financiranja",
      b4Title: "Financiranje postaje opipljivo.",
      b4Text: "Učešće, trajanje, mjesečna rata i završna (balonska) rata na prvi pogled — balonsko financiranje jasno objašnjeno.",
      b4Note: "Neobvezujući primjer izračuna za orijentaciju — bez kreditnog ili financijskog jamstva.",
      b5Kicker: "Prodaj svoje vozilo / AI procjena",
      b5Title: "I otkup postaje digitalan.",
      b5Text: "Kupci nude svoje vozilo online — i oštećeno ili nevozno. AI u sekundama daje prvi raspon cijene prije nego što trgovac preuzme.",
      b5Note: "Uvijek kao neobvezujuća AI procjena otkupa — konačnu procjenu donosi trgovac.",
      b6Kicker: "Dashboard za trgovca",
      b6Title: "Svaki upit strukturirano stiže u dashboard.",
      b6Text: "Upiti za otkup, rezervacije, probne vožnje i leadovi za financiranje — uključujući podatke o vozilu i AI predprocjenu. Umjesto izgubljenih poruka: uredan ulaz leadova.",
      b7Kicker: "AI Photo Studio",
      b7Title: "Vozilo ostaje. Showroom nastaje.",
      b7Text: "AI Photo Studio pretvara jednostavne fotografije vozila u kvalitetne showroom vizuale. View-Lock čuva perspektivu i detalje vozila što je više moguće — optimiziraju se pozadina, svjetlo i prezentacija.",
      b7SliderHint: "Povuci slider za usporedbu",
      baLabelBefore: "Originalna fotografija",
      baLabelAfter: "AI Showroom Preview",
      viewLockTitle: "View-Lock — kontrolirani AI workflow",
      viewLockPoints: [
        "Ista perspektiva i orijentacija vozila",
        "Karoserija, felge i svjetla ostaju očuvani",
        "Bez rotacije, bez preoblikovanja vozila",
        "Optimiziraju se samo pozadina, svjetlo, pod i showroom atmosfera",
        "Registarska oznaka može se neutralizirati",
      ],
      b7Note: "AI Showroom Preview — kontrolirani AI workflow umjesto nasumične generacije slika. Nije zamjena za finalne prodajne fotografije.",
      b8Kicker: "AI Background Manager",
      b8Title: "Vlastiti showroom svjetovi za dosljednu prezentaciju.",
      b8Text: "Ne samo foto efekt: trgovac bira i kreira vlastite AI pozadine — clean studio, showroom ili brand look — kako bi cijeli inventar izgledao dosljedno.",
      flowKicker: "Live Flow",
      flowTitle: "Stvarni lijevak — u pokretu.",
      flowText: "Desktop i mobile u izvornom tijeku: od showrooma do upita.",
      visit: "Pogledaj naautomobile.at",
    },
    nova: {
      kicker: "Case Study — stručna logika kao proizvod",
      headline: "Digitalni asistent za uvoz vozila s NoVA rule engineom.",
      intro: "NovaPilot nije jednostavan online kalkulator, već proizvod stručne logike: vođeni asistent za slučajeve, OCR dokumenti, PDV i cjenovna logika, indikator rizika i sljedivi PDF protokol izračuna.",
      b1Kicker: "Problem",
      b1Title: "Uvoz vozila je kompliciran.",
      b1Text: "NoVA, PDV, vrsta uvoza, podaci o vozilu, ključni datumi i dokumenti čine uvoz nepreglednim. NovaPilot to pretvara u vođen, dokumentiran slučaj.",
      b2Kicker: "Vođeni asistent za slučajeve",
      b2Title: "Prvo slučaj. Zatim logika.",
      b2Text: "Korisnik prvo bira odgovarajući poslovni slučaj — uvoz iz EU/EGP-a, uvoz iz treće zemlje, provjera postojećeg AT vozila ili izvoz s povratom NoVA-e. Wizard u 6 koraka razlaže složeni uvozni slučaj: za koga, vrsta slučaja, vozilo, PDV logika, procjena, potvrda.",
      b3Kicker: "Dokumenti i OCR",
      b3Title: "OCR potpomognut unos podataka i pohrana dokumenata.",
      b3Text: "Prometna dozvola, COC, računi i drugi dokumenti mogu se fotografirati, učitati, spremiti i putem OCR-a dodijeliti slučaju.",
      b4Kicker: "Rule Engine i logika pravnih verzija",
      b4Title: "Bez slijepe formule. Rule engine.",
      b4Text: "NoVA nije samo postotak: NovaPilot povezuje podatke o vozilu, cjenovnu logiku, PDV kontekst i ključne datume u strukturirani slučaj izračuna — uključujući osnovicu, procijenjenu vrijednost i pitanja plauzibilnosti.",
      ruleTitle: "Pravne verzije, primijenjene po slučaju",
      ruleText: "Engine uzima u obzir povijesne NoVA pravne verzije i verzije pravila te ih primjenjuje po slučaju: ovisno o odlučujućem datumu dokumentira se odgovarajuća verzija pravila s razdobljem važenja, izvorom i obrazloženjem.",
      ruleChips: ["Primijenjena pravna verzija", "ID pravila", "Razdoblje važenja", "Odlučujući datum", "Izvor: BMF / RIS NoVAG", "Obrazloženje"],
      b4bKicker: "PDV i cjenovna logika",
      b4bTitle: "PDV kontekst i procjena — korak po korak.",
      b4bText: "Tip prodavatelja, iskazani PDV i pretporez određuju PDV kontekst slučaja. Uz to dolazi cjenovna logika: osnovica, procijenjena vrijednost i izvor strukturirano se bilježe i kasnije dokumentiraju u protokolu.",
      b5Kicker: "PDF protokol izračuna",
      b5Title: "Rezultati se ne samo prikazuju — oni se dokumentiraju.",
      b5Text: "Svaki izračun može se izvesti kao sljediv protokol: poslovni slučaj, podaci o vozilu, primijenjena pravna verzija, korak-po-korak izračun, PDV i cjenovna logika, usporedba scenarija, indikator rizika, checklista dokumenata, izvori i pravni disclaimer.",
      b5PdfButton: "Pogledaj demo protokol (PDF)",
      b5Chips: ["Primijenjena pravna verzija", "Razdoblje važenja", "ID pravila", "Izvor: BMF / RIS NoVAG", "Obrazloženje", "Korak-po-korak izračun", "Indikator rizika", "Pravni disclaimer"],
      b5PdfNote: "Demo primjer — digitalna preliminarna dokumentacija za orijentaciju, a ne službeni izračun.",
      wizardSeq: [
        { kicker: "Za koga", title: "Za koga se računa?", text: "Trgovac ili privatna osoba — wizard prvo postavlja kontekstno pitanje. O tome ovisi koja se PDV i cjenovna logika kasnije primjenjuje." },
        { kicker: "Vrsta slučaja", title: "Koji poslovni slučaj postoji?", text: "Uvoz iz EU/EGP-a, uvoz iz treće zemlje, provjera postojećeg AT vozila ili izvoz s povratom — vrsta slučaja određuje pravila i odlučujuće datume." },
        { kicker: "Vozilo", title: "Podaci o vozilu, strukturirano prikupljeni.", text: "Prva registracija, CO2 vrijednost, snaga, kilometraža: wizard traži točno one podatke koji su ključni za NoVA izračun i dodjelu pravne verzije." },
        { kicker: "PDV logika", title: "PDV kontekst slučaja.", text: "Tip prodavatelja, iskazani PDV i pretporez se bilježe — iz toga proizlazi kako tumačiti kupovnu cijenu i osnovicu." },
        { kicker: "Procjena", title: "Procjena, plauzibilnost — i zatim rezultat.", text: "Procijenjena vrijednost i izvor čine osnovicu sljedivom. U posljednjem koraku korisnik potvrđuje podatke i dobiva dokumentirani izračun." },
      ],
      pdfSeq: [
        { kicker: "Stranica 1", title: "Izračun na prvi pogled.", text: "Poslovni slučaj, vozilo, odlučujući datum, osnovica i NoVA rezultat — uključujući usporedbu scenarija i indikator rizika već na prvoj stranici." },
        { kicker: "Stranica 2", title: "Pravna osnova i izvor — dokumentirano.", text: "Primijenjena pravna verzija, razdoblje važenja, verzija pravila (Rule-ID), izvor BMF / RIS NoVAG i obrazloženje dodjele pravne verzije stoje crno na bijelo u protokolu." },
        { kicker: "Stranica 3", title: "Put izračuna, korak po korak.", text: "NoVA izračun u detalje: osnovni iznos, bonus-malus, odbitci — plus PDV i cjenovna logika. Svaki korak je transparentno raščlanjen." },
        { kicker: "Stranica 4", title: "Procjena, indikator rizika i disclaimer.", text: "Odstupanja između kupovne cijene i procjene provjeravaju se i ocjenjuju indikatorom rizika. Upozorenja, checklista dokumenata, izvori i potpuna pravna napomena zaključuju protokol." },
      ],
      b6Kicker: "Lead funnel i Pro model",
      b6Title: "Istraživanje postaje produktni funnel.",
      b6Text: "Korisnici mogu spremati izračune, generirati PDF protokole i s NovaPilot Pro krenuti dalje — povijest, dokumentacija i slanje PDF-a uključeni. Mobile-first, od dashboarda do slučaja.",
      legalNote: "NovaPilot je računska priprema za orijentaciju — nije porezno savjetovanje, nije pravno savjetovanje i nije službeni alat porezne uprave. Konačnu provjeru obavlja stručna osoba ili nadležno tijelo.",
      flowKicker: "Live Flow",
      flowTitle: "Stvarni asistent — u pokretu.",
      flowText: "Desktop i mobile u izvornom tijeku: od slučaja do dokumentiranog izračuna.",
      visit: "Pogledaj novapilot.at",
    },
    uh: {
      kicker: "Case Study — Proces kao proizvod",
      headline: "Digitalni asistent za nezgode s AI zaprimanjem štete.",
      intro: "UnfallHeld pretvara nestrukturirane prijave šteta u upotrebljive digitalne slučajeve: vođena prijava nezgode, upload fotografija, glasovna snimka s AI strukturiranjem, OCR prometne dozvole, neobvezujuća AI prva procjena, PDF izvještaj o šteti i dashboard za servis.",
      b1Kicker: "Problem",
      b1Title: "Prijave šteta su kaotične.",
      b1Text: "Pozivi, raštrkane WhatsApp fotografije, nedostajući podaci o vozilu: za servise i lakirnice svaka prijava štete znači dodatna pitanja i gubitak vremena. UnfallHeld to pretvara u vođeni, dokumentirani slučaj.",
      b2Kicker: "Vođena prijava nezgode",
      b2Title: "Sedam jasnih koraka umjesto kaosa s formularima.",
      b2Text: "Kupac prijavljuje štetu korak po korak — osobni podaci, vozilo, nezgoda, fotografije, lokacija, druga strana, provjera i slanje. Mobile-first, izravno u pregledniku, bez preuzimanja aplikacije.",
      flowSeq: [
        { kicker: "Korak 1", title: "Osobni podaci.", text: "Ime i kontakt — više za početak ne treba. Kupac započinje prijavu u sekundama, bez registracije i bez preuzimanja aplikacije." },
        { kicker: "Korak 2", title: "Vozilo i prometna dozvola.", text: "Prometna dozvola se fotografira ili učita — OCR pomaže automatski prenijeti marku, model i broj šasije u slučaj." },
        { kicker: "Korak 3", title: "Izgovorite nezgodu umjesto tipkanja.", text: "Datum, vrijeme — i tijek nezgode kao glasovna poruka. AI iz toga strukturira urediv opis nezgode." },
        { kicker: "Korak 4", title: "Učitajte fotografije štete.", text: "Vođeni upload fotografija: pregledne i detaljne snimke štete prikupljaju se strukturirano — osnova za kasniju AI prvu procjenu." },
        { kicker: "Korak 5", title: "Mjesto nezgode putem GPS-a.", text: "Mjesto nezgode bilježi se na karti — dovoljan je jedan dodir. Slučaj je uredno dokumentiran i lokacijski." },
        { kicker: "Korak 6", title: "Druga strana s AI prepoznavanjem.", text: "Fotografije vozačke i prometne dozvole druge strane preuzimaju se uz AI podršku — uključujući podatke o osiguranju." },
        { kicker: "Korak 7", title: "Provjeri i pošalji.", text: "Svi podaci na jednom mjestu, zatim slanje: kupac dobiva broj slučaja i PIN — servis strukturirani, upotrebljiv slučaj." },
      ],
      b3Kicker: "Govoriti umjesto tipkati",
      b3Title: "Tijek nezgode jednostavno se izgovori.",
      b3Text: "Umjesto dugog tipkanja, kupac snima tijek nezgode kao glasovnu poruku. Iz toga nastaju transkript i AI strukturirani, uredivi opis nezgode.",
      b4Kicker: "Fotografije, lokacija i druga strana",
      b4Title: "Sve činjenice na jednom mjestu.",
      b4Text: "Fotografije štete prikupljaju se strukturirano, mjesto nezgode bilježi se GPS-om, a podaci druge strane — uključujući fotografije vozačke i prometne dozvole — preuzimaju se uz AI podršku.",
      b5Kicker: "OCR prometne dozvole",
      b5Title: "Podaci o vozilu bez pretipkavanja.",
      b5Text: "Prometna dozvola se fotografira ili učita — OCR pomaže brže prenijeti marku, model, broj šasije i prvu registraciju u slučaj.",
      b6Kicker: "AI prva procjena i status",
      b6Title: "Prva procjena — neobvezujuća i transparentna.",
      b6Text: "AI strukturirano sažima vidljivu štetu: prepoznate dijelove, težinu i pouzdanost. Kupac prati slučaj putem broja slučaja i PIN-a na statusnoj traci — od prijave do rješavanja.",
      kiTitle: "Predkvalifikacija, a ne vještačenje",
      kiText: "AI prva procjena strukturira vidljivu štetu kao brzu polaznu točku za daljnju obradu. Konačnu procjenu uvijek radi servis, vještak ili osiguranje.",
      kiChips: ["Prepoznate štete", "Težina", "Pouzdanost", "Neobvezujuća prva procjena", "Checklista dokumenata", "Statusna traka", "Broj slučaja + PIN"],
      b7Kicker: "PDF izvještaj o šteti",
      b7Title: "Prijava postaje strukturirani dosje štete.",
      b7Text: "Svaki slučaj može se izvesti kao PDF izvještaj o šteti: podaci o slučaju i vozilu, AI prva procjena s pouzdanošću, originalni glasovni transkript, fotografije nezgode, sažetak osiguranja, preporučeni sljedeći koraci i jasna napomena o neobvezujućoj prirodi.",
      b7Chips: ["Podaci o slučaju i vozilu", "AI procjena + pouzdanost", "Originalni glasovni transkript", "Fotografije nezgode", "Sažetak osiguranja", "Preporučeni sljedeći koraci", "Važna napomena (neobvezujuće)"],
      b7PdfButton: "Pogledaj demo izvještaj (PDF)",
      b7PdfNote: "Demo primjer — neobvezujuća prva procjena za predkvalifikaciju, a ne vještačenje.",
      b8Kicker: "Dashboard za servis i lead flow",
      b8Title: "Svaka prijava postaje upotrebljiv slučaj.",
      b8Text: "U dashboardu servis vidi sve slučajeve šteta sa statusom, 10-sekundnim briefingom, checklistom dokumenata i brzim kontaktom putem poziva ili WhatsAppa — od zaprimanja do završetka.",
      flowKicker: "Live Flow",
      flowTitle: "Pravi asistent — u pokretu.",
      flowText: "Desktop i mobile u originalnom tijeku: od prijave do strukturiranog slučaja štete.",
      legalNote: "UnfallHeld pruža AI podržanu, neobvezujuću prvu procjenu za predkvalifikaciju — nije vještačenje, nema obvezujuće procjene štete ili troškova, nema pravnog savjetovanja ni jamstva pokrića. Konačnu procjenu radi servis, vještak ili osiguranje.",
      visit: "Pogledaj unfallheld.com",
    },
    wall: {
      kicker: "Reference",
      title: "Bez predložaka. Stvarni proizvodi.",
      subtitle: "Šest platformi koje smo osmislili, izgradili i lansirali — od AI SaaS-a do premium commercea.",
      visit: "Pogledaj uživo",
      caseStudy: "Pogledaj case study",
      assetNeeded: "Potreban asset",
      comingSoon: "Case study uskoro",
    },
    caseNav: {
      back: "Natrag na reference",
      viewCase: "Pogledaj case study",
      ctaTitle: "Spremni za vlastiti proizvod?",
      ctaText: "Porazgovarajmo o vašem projektu — od ideje do lansiranja.",
    },
    categories: {
      catAiSaas: "AI SaaS · Asset Intelligence",
      catB2bSaas: "B2B SaaS · TaxTech",
      catInsurtech: "InsurTech · AI štete",
      catAutomotiveAi: "Automotive AI · Leads",
      catRetail: "Retail · AI Commerce",
      catAutomotive: "Automotive · Platforma",
    },
    projects: {
      dealalert: {
        claim: "AI pronalazi najbolje ponude auta i nekretnina — prije svih.",
        positioning: "AI asset intelligence za aute i nekretnine.",
        description: "DealAlert analizira oglase auta i nekretnina, konzervativno procjenjuje tržišne cijene i prikazuje stvarne ponude ispod tržišta — na webu i iOS-u.",
      },
      novapilot: {
        claim: "Digitalni asistent za uvoz vozila s NoVA rule engineom.",
        positioning: "Složena NoVA logika. Jednostavno vođena.",
        description: "NovaPilot vodi kroz složene austrijske NoVA slučajeve — rule engine, vođeni wizard, OCR dokumenti i sljedivi PDF protokol izračuna.",
      },
      unfallheld: {
        claim: "Digitalni asistent za nezgode s AI zaprimanjem štete.",
        positioning: "Prijava štete, OCR i PDF dosje u jednom mobilnom flowu.",
        description: "UnfallHeld digitalizira prijavu štete: vođena prijava nezgode, upload fotografija, glasovni transkript, OCR prometne dozvole, neobvezujuća AI prva procjena, PDF izvještaj o šteti i dashboard za servis.",
      },
      naperformance: {
        claim: "AI performance advisor za optimizaciju vozila.",
        positioning: "AI performance advisor za optimizaciju vozila.",
        description: "Učitaj prometnu dozvolu — AI prepoznaje vozilo i izrađuje realističnu tuning analizu s usporedbom prije/poslije i WhatsApp lead flowom.",
      },
      hausdeshandys: {
        claim: "Premium digitalizacija za servis pametnih telefona.",
        positioning: "Premium digitalizacija za retail i servis.",
        description: "Konfigurator popravaka sa stvarnim cijenama, AI shopping asistent, partnerske sekcije i admin dashboard — kompletno digitalno iskustvo trgovine.",
      },
      naautomobile: {
        claim: "Premium platforma za autosalon s AI Photo Studiom.",
        positioning: "Premium platforma za autosalon s AI Photo Studiom.",
        description: "Inventar vozila, WhatsApp-first prodaja, rezervacije, AI procjena vozila, AI Photo Studio i kalkulator balonskog financiranja.",
      },
    },
    dealalert: {
      kicker: "Flagship case study",
      headline: "Od ideje do kompletne AI platforme.",
      subline: "DealAlert je AI-powered deal intelligence za oglase auta i nekretnina — usporedba tržišta umjesto obećanja, jasan cjenovni signal na webu i iOS-u.",
      visit: "Posjeti dealalert.ai",
      videoNote: "Screen recording iz iOS aplikacije",
      problem: {
        kicker: "Problem",
        title: "Tisuće oglasa. Gotovo bez usporedivosti.",
        text: "Portali za aute i nekretnine prikazuju oglase — ali ne i je li ponuda stvarno dobra. Cijene je teško procijeniti, rizici ostaju nevidljivi, a dobre ponude često nestanu prije nego ih stigneš ocijeniti.",
        points: [
          "Oglasi bez stvarnog tržišnog konteksta",
          "Procjena cijene traži sate istraživanja",
          "Dobre ponude brzo nestaju",
        ],
      },
      solution: {
        kicker: "Rješenje",
        title: "Platforma koja razumije oglase.",
        text: "DealAlert agregira oglase, normalizira podatke o vozilima i nekretninama i konzervativno ih uspoređuje s odgovarajućim tržišnim kohortama. Rezultat je sljediv cjenovni signal — ne jamstvo, nego AI-podržana procjena.",
        points: [
          "Data pipeline i normalizacija",
          "Konzervativna usporedba tržišta, bez lažnih popusta",
          "Jasan cjenovni signal izravno na oglasu",
        ],
      },
      flow: {
        kicker: "Product flow",
        title: "Od oglasa do odluke.",
        subtitle: "Četiri koraka: otkrij, procijeni, pitaj AI, djeluj — na webu i iOS-u.",
        steps: [
          { num: "01", label: "Discover", title: "Otkrij ponude.", text: "Top Deals i swipeable DealFeed ističu odgovarajuće oglase auta i nekretnina — najjači signali prvi. Otkrivanje kao u modernoj consumer aplikaciji." },
          { num: "02", label: "Evaluate", title: "Procijeni ponude.", text: "DealCard prikazuje cijenu, podatke o vozilu ili nekretnini, slike i konzervativni tržišni signal. Usporedba sa sličnim ponudama čini kontekst vidljivim — umjesto osjećaja." },
          { num: "03", label: "Ask AI", title: "Pitaj AI.", text: "AI Deal Advisor objašnjava cijenu, rizike, prinos i lokaciju — izravno na oglasu. AI-podržana procjena koja čini rizike vidljivijima. Nije obvezujući savjet." },
          { num: "04", label: "Save & Act", title: "Spremi i djeluj.", text: "Spremi favorite, postavi profile pretrage i preporuči kroz Share & Earn. Od signala do konkretnog sljedećeg koraka — brže donesi utemeljenu odluku." },
        ],
      },
      tech: {
        kicker: "Sustav iza",
        title: "Pravi SaaS proizvod — ne samo aplikacija.",
        text: "Iza feeda stoji kompletna platforma: data pipeline, engine za usporedbu tržišta, AI advisor, pretplata i admin. Upravo to gradi CloudService — kompletne digitalne proizvode umjesto web stranica.",
        items: [
          { name: "Data pipeline", desc: "Apify uvoz i normalizacija oglasa auta i nekretnina." },
          { name: "Market engine", desc: "Konzervativna usporedba s tržišnim kohortama — slabi podaci, nema signala." },
          { name: "AI Deal Advisor", desc: "Claude / GPT procjena cijene, rizika i prinosa na oglasu." },
          { name: "Image health worker", desc: "Provjerava i čisti podatke o slikama da feed ostane čist." },
          { name: "Stripe pretplata", desc: "Model pretplate s referral i Share & Earn sustavom." },
          { name: "Admin dashboard", desc: "Monitoring pipelinea i upravljanje oglasima na jednom mjestu." },
        ],
      },
      value: {
        kicker: "Business value",
        title: "Brže i bolje odluke.",
        text: "DealAlert čini rizike vidljivijima a ponude usporedivima — da korisnici brže i informiranije odluče. Namjerno konzervativno umjesto senzacionalno: to je dio kvalitete proizvoda, bez zajamčene dobiti.",
      },
      stats: [
        { value: 5000, suffix: "+", label: "analiziranih oglasa" },
        { value: 6, suffix: "", label: "ključnih modula" },
        { value: 2, suffix: "", label: "platforme — web + iOS" },
        { value: 2, suffix: "", label: "tržišta — auti + nekretnine" },
      ],
      finalCta: {
        kicker: "Rezultat",
        title: "Kompletan SaaS proizvod — uživo na dealalert.ai.",
        text: "Web aplikacija, iOS aplikacija, AI Deal Advisor, data pipeline, pretplata, referral i admin — CloudService ih gradi kao kompletan proizvod.",
        primary: "Pogledaj dealalert.ai uživo",
      },
    },
    shells: {
      kicker: "Case study",
      assetNote: "Stvarni product screenovi dolaze — layout spreman za finalne assete.",
      desktopLabel: "Desktop — potreban asset",
      mobileLabel: "Mobile — potreban asset",
      visit: "Pogledaj uživo",
    },
    pillars: {
      kicker: "Usluge",
      title: "Što CloudService gradi",
      subtitle: "Četiri područja — jedan standard: stvarni proizvodi umjesto website buildera.",
      items: [
        { title: "AI Solutions", text: "Inteligencija koja stvarno preuzima procese.", bullets: ["OCR i prepoznavanje dokumenata", "AI advisori i chatbotovi", "Analiza slika i voice-to-text"] },
        { title: "SaaS Platforms", text: "Od logina do pretplate — spremno za produkciju.", bullets: ["Auth, Stripe i pretplate", "Korisnički i admin dashboardi", "Skalabilni API-ji"] },
        { title: "Mobile Apps", text: "iOS i Android koji se osjećaju kao consumer aplikacije.", bullets: ["iOS / Android / Expo", "Swipe sučelja", "Spremno za App Store"] },
        { title: "Business Automation", text: "Interni alati koji vraćaju vrijeme.", bullets: ["CRM i lead management", "PDF generatori i računi", "Dashboardi i interni alati"] },
      ],
    },
    industries: {
      kicker: "Industrije",
      title: "Izgrađeno za stvarne industrije",
      subtitle: "Svaka industrija ovdje potvrđena je stvarnim projektom koji radi uživo.",
      items: [
        { name: "Automotive", project: "NAAutomobile · NAPerformance" },
        { name: "Nekretnine", project: "DealAlert" },
        { name: "Osiguranje / Štete", project: "UnfallHeld" },
        { name: "Retail / Servis", project: "HausDesHandys" },
        { name: "Porezi / Compliance", project: "NovaPilot" },
        { name: "SaaS / Startupi", project: "DealAlert · NovaPilot" },
      ],
    },
    process: {
      kicker: "Proces",
      title: "Od ideje do proizvoda",
      subtitle: "Jasno, brzo, bez agencijskog teatra.",
      steps: [
        { title: "Razumjeti ideju", text: "Ciljevi, podaci, korisnici i ograničenja — slušamo prije nego gradimo." },
        { title: "Definirati koncept proizvoda", text: "Flowovi, arhitektura i scope — kao jasna zajednička slika." },
        { title: "Izgraditi MVP", text: "Funkcionalan proizvod — u pravilu u tjednima, ne mjesecima." },
        { title: "Integrirati AI i automatizaciju", text: "OCR, advisori, pipeline — tamo gdje donose stvarnu vrijednost." },
        { title: "Lansirati", text: "Deployment, monitoring, payment flow — spremno za produkciju." },
        { title: "Stalno poboljšavati", text: "Iteracija na temelju stvarnog korištenja — proizvod raste s vama." },
      ],
    },
    contact: {
      kicker: "Kontakt",
      title: "Pokreni projekt",
      subtitle: "Reci nam što želiš izgraditi. Odgovaramo s konkretnim koracima — ne standardnom brošurom.",
      name: "Ime",
      company: "Tvrtka",
      email: "E-mail",
      phone: "Telefon",
      projectType: "Vrsta projekta",
      projectTypePlaceholder: "Što treba izgraditi?",
      projectTypes: ["Website", "Web aplikacija", "Mobilna aplikacija", "AI alat", "Automatizacija", "CRM / Admin Dashboard", "SaaS platforma", "E-Commerce", "Nisam siguran/na"],
      industry: "Industrija",
      industryPlaceholder: "Odaberi industriju",
      industryOptions: ["Automotive", "Nekretnine", "Osiguranje", "Retail / Trgovina", "Porezi / Compliance", "SaaS / Startup", "Ostalo"],
      budget: "Budžet",
      budgetPlaceholder: "Odaberi budžet",
      budgetOptions: ["< 3.000 €", "3.000 – 10.000 €", "10.000 – 25.000 €", "25.000 € +", "Još otvoreno"],
      timeline: "Vremenski okvir",
      timelinePlaceholder: "Odaberi vremenski okvir",
      timelineOptions: ["Što prije / unutar 2 tjedna", "Unutar 1 mjeseca", "1–3 mjeseca", "3+ mjeseci", "Još otvoreno / želim savjetovanje"],
      description: "Opis projekta",
      descriptionPlaceholder: "Što želiš izgraditi? Koji problem treba riješiti?",
      file: "Priloži datoteku (opcionalno)",
      fileHint: "PDF, slike, dokumenti — maks. 10 MB",
      preferredContact: "Preferirani kontakt",
      contactOptions: { email: "E-mail", phone: "Telefon", whatsapp: "WhatsApp" },
      submit: "Pošalji upit",
      submitting: "Šalje se…",
      successTitle: "Upit zaprimljen!",
      successText: "U pravilu se javljamo unutar 24 sata s konkretnim sljedećim koracima.",
      successWhatsapp: "Piši nam na WhatsApp",
      successEmail: "Ili izravno e-mailom",
      newRequest: "Pošalji novi upit",
      errorRequired: "Molimo ispuni sva obavezna polja.",
      errorSubmit: "Slanje nije uspjelo. Pokušaj ponovno.",
      errorFile: "Upload datoteke nije uspio. Poslati bez datoteke?",
    },
    footer: {
      tagline: "AI Solutions. SaaS Platforms. Mobile Apps. Business Automation.",
      projects: "Projekti",
      legal: "Pravno",
      imprint: "Impressum",
      privacy: "Privatnost",
      contact: "Kontakt",
      rights: "Sva prava pridržana.",
    },
  },
};

const LanguageContext = createContext({ lang: "de", setLang: () => {}, t: translations.de });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem("cs_lang");
    return LANGS.includes(stored) ? stored : "de";
  });

  const setLang = useCallback((l) => {
    if (LANGS.includes(l)) {
      setLangState(l);
      localStorage.setItem("cs_lang", l);
      document.documentElement.lang = l;
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}

